<template>
	<div class="tiger-bet-loader" :style="{ display: displayLoader || CashoutLoader ? 'flex' : 'none' }"> <img loading="lazy" src="@/assets/images/loader.webp" alt="loader"> </div>
	<div class="market-and-tv-logo" v-if="this.$route.name == 'SportsEventDetail'">
		<div class="sport-event-cmn-h">
			<div class="event-lft-h">
				<ul>
					<li class="" v-if="!eventDetails?.is_exclusive">
						<a href="javascript:void(0)" :class="{ 'active' : currentTab == 'market'}" id="market-show" @click="marketShow()" aria-label="Open Market"> <img loading="lazy" src="@/assets/images/profitloss.webp" alt="profitloss">
							<br> <span>{{ $t('market','Market')}}</span> </a>
					</li>
                    <template v-if="$auth?.status">
                        <li class="">
						    <a href="javascript:void(0)" :class="{ 'active' : showScoreCard}" class="live-tv-handle-tab" @click="toggleScoreCard()" aria-label="score"> <img loading="lazy" src="@/assets/images/scorecard_icon.svg" alt="tv-white">
							<br> <span>{{ $t('score','Score')}}</span> </a>
                        </li>
                        <li class="" v-if="!eventDetails?.is_exclusive">
                            <a href="javascript:void(0)" :class="{ 'active' : showTv}" class="live-tv-handle-tab" @click="toggleTv()" aria-label="tv "> <img loading="lazy" src="@/assets/images/tv-white.webp" alt="tv-white">
                                <br> <span>{{ $t('tv','TV')}}</span> </a>
                        </li>
                        <li class="" v-if="!eventDetails?.is_exclusive">
                            <a href="javascript:void(0)" :class="{ 'active' : currentTab == 'bet'}" id="bets-slips" @click="betSlip()" aria-label="bets"> <img loading="lazy" src="@/assets/images/bets.webp" alt="bets">
                                <br> <span>{{ $t('bets-small','Bets')}}</span> </a>
                        </li>
                    </template>
					
                    <li v-if="!eventDetails?.is_exclusive">
                        <div class="event-rgt-h">
                            <button class="apply_filter_btn" type="button" data-bs-target="#filterModal" data-bs-toggle="modal" aria-label="bets" :class="{'active': eventDetailHideSections?.length}"> 
                                <img loading="lazy" src="@/assets/images/filter_icon.svg" alt="filter" class="inactive-filter">
                                <img loading="lazy" src="@/assets/images/filter_fill.svg" alt="filter" class="active-filter">
                                <span>{{$t('filters', 'Filters')}}</span>
                            </button>
                        </div>
                    </li>
				</ul>
			</div>
			
		</div>
	</div>
	<div class="book-maker-and-odd-sec">
		<div class="container-fluid">
			<div class="row g-0">
				<div class="col-12 col-sm-12 col-md-12 col-lg-8">
					<div class="live-tv-sec" id="live-tv-pin">
						<div class="avaliable-tv">
							<figure>
								<iframe :src='"https://vid.dreamcasino.live/GetAPI.html?MatchID=" + eventDetails.eventId' scrolling="no" frameborder="0" class="tv-iframe"></iframe>
							</figure>
						</div>
					</div>
					<div v-if="showScoreCard" class="card card-body p-0">
						<div class="score-img" v-if="eventDetails.sportsradar_id && isVisible == false">
							<iframe id="sportradar_score" :src="'https://scorecard.oddstrad.com/get-scorecard-iframe/' + eventDetails.sportId + '/' + eventDetails.eventId + '/' + eventDetails.sportsradar_id" marginwidth="0" marginheight="0" frameborder="0" width="100%" scrolling="no" allowfullscreen="allowfullscreen" style="height: 177px;" class="sports-radar-scorecard-iframe"></iframe>
						</div>
					</div>
					<div class="bets-details-in-mobile" id="bets-detail">
						<div class="match-and-unmatch-sec">
                            <div class="average-odds-right m-2">
                                <input class="form-check-input"
                                type="checkbox" id="pageFiltershow_full_screen" value="show_full_screen"
                                v-model="averageOdds">
                                <label class="form-check-label" for="pageFiltershow_full_screen">{{ $t('average-odds','Average Odds') }}</label>
                            </div>
							<nav>
								<div class="nav nav-tabs" id="nav-tab" role="tablist">
									<button class="nav-link" :class="{active : activeOpenBetType == 'main_market'}" id="nav-matched-tab" type="button" @click="activeOpenBetType = 'main_market'">{{ $t('matched','Matched')}} <span>({{ filteredOpenBets?.main_market?.length ?? 0}})</span></button>
									<button class="nav-link" id="nav-unmatched-tab" type="button" :class="{active : activeOpenBetType == 'bookmakers'}" @click="activeOpenBetType = 'bookmakers'">{{ $t('bookmaker','Bookmaker')}} <span>({{ filteredOpenBets?.bookmakers?.length ?? 0}})</span></button>
									<button class="nav-link" id="nav-fancy-tab" type="button" :class="{active : activeOpenBetType == 'fancies'}" @click="activeOpenBetType = 'fancies'">{{ $t('fancy','Fancy')}} <span>({{ filteredOpenBets?.fancies?.length ?? 0}})</span></button>
								</div>
							</nav>
							<div>
								<div class="" id="" role="tabpanel" aria-labelledby="nav-matched-tab">
									<div class="matched-details-sec">
                                        <template v-if="!averageOdds">
                                            <div class="bet-details-table table-responsive">
                                                <table class="table">
                                                    <thead>
                                                        <tr class="matched-heading t-bet-body">
                                                            <th><b>{{ $t('selection','Selection')}}</b></th>
                                                            <th><b>{{ $t('odds','Odds')}}</b></th>
                                                            <th><b>{{ $t('stake','Stake')}}</b></th>
                                                            <th><b>{{ $t('date-time','Date/Time')}}</b></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-if="(filteredOpenBets?.[activeOpenBetType]?.length ?? 0) > 0">
                                                            <tr class="t-bet-body" :class="bet.selection_type == 'back' ? 'back-background' : 'lay-background'" v-for="(bet, bet_index) in filteredOpenBets[activeOpenBetType]" :key="bet_index">
                                                                <td><span class="cashout-Box" v-if="bet?.is_cashout">C</span> {{ bet.selection }}</td>
                                                                <td>{{ bet.odds }}</td>
                                                                <td>{{ bet.stake }}</td>
                                                                <td>{{ $dateTime.convertUnixDate(bet.bet_timestamp_date, 'DD/MM/YYYY HH:mm:ss') }}</td>
                                                            </tr>
                                                        </template>
                                                    
                                                        <template v-else>
                                                            <tr class="nodata_found_msg">
                                                                <td colspan="4">
                                                                    <NoDataFound /> 
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="bet-details-table table-responsive">
                                                <table class="table">
                                                    <thead>
                                                        <tr class="matched-heading">
                                                            <th><b>{{ $t('selection','Selection')}}</b></th>
                                                            <th><b>{{ $t('odds','Odds')}}</b></th>
                                                            <th><b>{{ $t('stake','Stake')}}</b></th>
                                                            <th><b>{{ $t('profit-liability', 'Profit/Liability') }}</b></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-if="parseInt(getMarketDataByName(activeOpenBetType).lay.betCount + getMarketDataByName(activeOpenBetType).back.betCount) > 0">
                                                            <tr class="lay-background">
                                                                <td>{{$t('lay', 'Lay')}}</td>
                                                                <td>{{ getMarketDataByName(activeOpenBetType).lay.odds }}</td>
                                                                <td>{{ getMarketDataByName(activeOpenBetType).lay.stake }}</td>
                                                                <td>{{ getMarketDataByName(activeOpenBetType).lay.pl }}</td>
                                                            </tr>
                                                            <tr class="back-background">
                                                                <td>{{$t('back', 'Back')}}</td>
                                                                <td>{{ getMarketDataByName(activeOpenBetType).back.odds }}</td>
                                                                <td>{{ getMarketDataByName(activeOpenBetType).back.stake }}</td>
                                                                <td>{{ getMarketDataByName(activeOpenBetType).back.pl }}</td>
                                                            </tr>
                                                        </template>
                                                        <template v-else>
                                                            <tr class="nodata_found_msg">
                                                                <td colspan="4">
                                                                    <NoDataFound /> 
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </template>
									</div>
								</div>
							</div>
						</div>
					</div>
                    <template v-if="matchOddsData?.length > 0 || bookmakerData?.length > 0 || fancyData?.length > 0 || eventDetails?.hasPremiumFancy == 1">
                        <!-- Match Odds & Who Will Win The Match?--> 
                        <template v-if="!eventDetails?.is_exclusive && isVisible == false && eventDetailHideSections && !eventDetailHideSections.includes('match_odds')">
                            <template v-for="(market, m_index) in matchOddsData" :key="m_index">
                                <template v-if="market.marketName == 'Match Odds' || market.marketName == 'Who Will Win The Match?'">
                                    <div class="bok-maker-header-line">
                                        <div class="odds-title-row">
                                            <div :class="market.marketName == 'Who Will Win The Match?'?'col-12':'odds-match-title-left'">
                                                <div class="header-line-left">
                                                    <div class="booker-maker-winner-l">
                                                        <!-- <img v-if="market.favourite" src="@/assets/images/star-selected.webp" alt=""
                                                            @click="unFavorite(market)"> -->
                                                        <div v-if="market.marketName == 'Match Odds'" @click="makeFavourite(market)"> <img v-if="eventDetails.favourite" src="@/assets/images/star-selected.webp" alt="star-selected"> <img v-else src="@/assets/images/star-dark.webp" alt="star-selected"> </div> <span> {{ market.marketName.toUpperCase() }} <span v-if="market.marketName == 'Who Will Win The Match?'" >(Incl. Super Over)</span></span>
                                                        <template v-if="$auth.status && (market.marketName == 'Match Odds' || (market.marketName == 'Who Will Win The Match?' && market.runners.length == 2))">
                                                            <div class="btn cashout-btn" v-if="!cashoutMarketData[market.mid] || (cashoutMarketData[market.mid] && !cashoutMarketData[market.mid].value)">{{ $t('cashout','Cashout')}}</div>
                                                            <div class="btn cashout-btn" data-bs-toggle="modal" data-bs-target="#cashout-modal" v-html="cashoutMarketData[market.mid].value" @click="cashoutServiceCall(market, 'market')" v-else></div>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                            <div :class="market.marketName == 'Who Will Win The Match?'?'col-0 ':'odds-yesno-right'" v-if="market.marketName == 'Match Odds'">
                                                <div class="header-line-right"> 
                                                    <!-- <span>MIN: {{ market.min_stake_limit ? market.min_stake_limit : 0 }}</span> -->
                                                    <span>{{ $t('max-cap','MAX')}} : {{ market.stake_limit ? market.stake_limit : 0 }}</span> 
                                                    <!-- <span class="back-lay">{{ $t('back','Back')}}</span> <span class="back-lay">{{ $t('lay','Lay')}}</span>  -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="market.marketName == 'Match Odds'">
                                        <div class="bg-light" v-for="(runner, r_index) in market.runners" :key="r_index">
                                            <div class="odds-bookmaker-row">
                                                <div class="odds-bookmaker-col-left">
                                                    <div class="runner-city text-truncate"> 
                                                        <span>{{ runner.runner_name }}</span>
                                                        <span class="back-lay-status" v-html="getRunnerBookHtml(market.mid, runner.sid, 'm')"> </span> 
                                                    </div>
                                                </div>
                                                <div class="odds-bookmaker-col-right">
                                                    <div class="back-odd-box open-bet-box">
                                                        <button type="button" class="back1" ref="check" @click="runner?.ex?.b?.[2]?.p && addBet(market, runner, 'back', 'market', r_index, $event)"> <span>{{ runner.ex.b?.[2] ? runner.ex.b?.[2].p : '' }}</span>
                                                            <span class="text-0" v-if="runner.ex.b?.[2]">{{ runner.ex.b?.[2] ? runner.ex.b?.[2].s : ''
                                                            }}</span> </button>
                                                        <button type="button" class="back2" @click="runner?.ex.b?.[1]?.p && addBet(market, runner, 'back', 'market', r_index, $event)"> <span>{{ runner.ex.b?.[1] ? runner.ex.b?.[1].p : '' }}</span>
                                                                <span class="text-0" v-if="runner.ex.b?.[1]">{{ runner.ex.b?.[1] ? runner.ex.b?.[1].s : ''
                                                            }}</span> </button>
                                                        <button type="button" class="sky-blue-box1" @click="runner?.ex.b?.[0]?.p && addBet(market, runner, 'back', 'market', r_index, $event)"> <span>{{ runner.ex.b?.[0] ? runner.ex.b?.[0].p : '' }}</span>
                                                            <span class="text-0" v-if="runner.ex.b?.[0]">{{ runner.ex.b?.[0] ? runner.ex.b?.[0].s : ''
                                                            }}</span> </button>
                                                        <button type="button" class="light-pink-box1" @click="runner?.ex.l?.[0]?.p && addBet(market, runner, 'lay', 'market', r_index, $event)"> <span>{{ runner.ex.l?.[0] ? runner.ex.l?.[0].p : '' }}</span>
                                                                <span class="text-0" v-if="runner.ex.l?.[0]">{{ runner.ex.l?.[0] ? runner.ex.l?.[0].s : ''
                                                            }}</span> </button>
                                                        <button type="button" class="lay1" @click="runner?.ex.l?.[1]?.p && addBet(market, runner, 'lay', 'market', r_index, $event)"> <span>{{ runner.ex.l?.[1] ? runner.ex.l?.[1].p : '' }}</span>
                                                            <span class="text-0" v-if="runner.ex.l?.[1]">{{ runner.ex.l?.[1] ? runner.ex.l?.[1].s : ''
                                                            }}</span> </button>
                                                        <button type="button" class="lay2" @click="runner?.ex.l?.[2]?.p && addBet(market, runner, 'lay', 'market', r_index, $event)"> <span>{{ runner.ex.l?.[2] ? runner.ex.l?.[2].p : '' }}</span>
                                                            <span class="text-0" v-if="runner.ex.l?.[2]">{{ runner.ex.l?.[2] ? runner.ex.l?.[2].s : ''
                                                            }}</span> </button>
                                                        <div class="suspended-match abonded-match" v-if="runner.s != 'ACTIVE' || market.st != 'OPEN'">
                                                            <button type="button" class=""> {{ $t('suspended','SUSPENDED')}} </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="bg-light">
                                            <div class="who-will-win-wrapper">
                                                <div class="who-will-win-sec" v-for="(runner, r_index) in market.runners" :key="r_index">
                                                    <div class="back-odd-box">
                                                        <div class="runner-city text-truncate"> 
                                                            <span>{{ runner.runner_name }}</span>
                                                            <span class="back-lay-status" v-html="getRunnerBookHtml(market.mid, runner.sid, 'm')"> </span> 
                                                        </div>
                                                        <button type="button" class="sky-blue-box1" @click="runner.ex.b?.[0]?.p && addBet(market, runner, 'back', 'market', r_index, $event)"> <span>{{ runner.ex.b?.[0] ? runner.ex.b?.[0].p : '' }}</span>
                                                            <span class="text-0" v-if="runner.ex.b?.[0]">{{ runner.ex.b?.[0] ? runner.ex.b?.[0].s : ''
                                                            }}</span> </button>
                                                        <div class="suspended-match abonded-match" v-if="runner.s != 'ACTIVE' || market.st != 'OPEN'">
                                                            <button type="button" class=""> {{ $t('suspended','SUSPENDED')}} </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <div class="marquee-show-msg" v-if="market?.msg || (market?.msg && market?.msg != '')">
                                    <div class="msgs" style="width: 100vw">
                                        <marquee>
                                            <i class="mdi mdi-email mr-1"></i> {{ market?.msg }}
                                        </marquee>
                                    </div>
                                </div>
                            </template>
                        </template>
                        <!-- Bookmakers -->
                        <div v-if="!eventDetails?.is_exclusive && bookmakerData && bookmakerData.ml && isVisible == false && eventDetailHideSections && !eventDetailHideSections.includes('bookmakers')">
                            <div class="book-maker-section winner-cup" v-for="(bookmaker, b_index) in bookmakerData.ml" :key="b_index">
                                <div class="bok-maker-header-line">
                                    <div class="odds-title-row">
                                        <div class="odds-match-title-left">
                                            <div class="header-line-left">
                                                <div class="booker-maker-winner-l">
                                                    <!-- <img loading="lazy" src="@/assets/images/star-dark.webp" alt="">
                                                    <img loading="lazy" src="@/assets/images/star-selected.webp" alt=""> --><span>{{ bookmaker.mn.toUpperCase() }}</span>
                                                    <template v-if="$auth.status &&  bookmaker.sl.length <= 2">
                                                        <div class="btn cashout-btn" v-if="!cashoutMarketData[bookmaker.mi] || (cashoutMarketData[bookmaker.mi] && !cashoutMarketData[bookmaker.mi].value)">{{ $t('cashout','Cashout')}}</div>
                                                        <div class="btn cashout-btn" data-bs-toggle="modal" data-bs-target="#cashout-modal" v-html="cashoutMarketData[bookmaker.mi].value" @click="cashoutServiceCall(bookmaker, 'bookmaker')" v-else></div>
                                                    </template>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div class="odds-yesno-right">
                                            <div class="header-line-right"> 
                                                <!-- <span class="back-lay">{{ $t('back','Back')}}</span> <span class="back-lay">{{ $t('lay','Lay')}}</span>  -->
                                                    <!-- <span>MIN:{{ bookmaker.mins ? bookmaker.mins : 0 }}</span> -->
                                                <span>{{ $t('max-cap','MAX')}} : {{ bookmaker.ms ? bookmaker.ms : 0 }}</span> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="bg-light" v-for="(runner, r_index) in bookmaker.sl" :key="r_index">
                                    <div class="odds-bookmaker-row">
                                        <div class="odds-bookmaker-col-left">
                                            <div class="runner-city text-truncate"> 
                                                <span>{{ runner.sln }}</span>
                                                <span class="back-lay-status" v-html="getRunnerBookHtml(bookmaker.mi, runner.si, 'b')"></span> 
                                            </div>
                                        </div>
                                        <div class="odds-bookmaker-col-right">
                                            <div class="back-odd-box">
                                                <button type="button" class="sky-blue-box1" @click="runner.b && addBet(bookmaker, runner, 'back', 'bookmaker', r_index, $event)"> <span>{{ runner.b ? runner.b : '' }}</span>
                                                    <span class="text-0" v-if="runner.b">{{ bookmaker.ms ? bookmaker.ms :''}}</span> </button>
                                                <button type="button" class="light-pink-box1" @click="runner.l && addBet(bookmaker, runner, 'lay', 'bookmaker', r_index, $event)"> <span>{{ runner.l ? runner.l : '' }}</span>
                                                    <span class="text-0" v-if="runner.l">{{ bookmaker.ms ? bookmaker.ms :''}}</span> </button>
                                                <div class="suspended-match abonded-match" v-if="bookmaker.sn != 'ONLINE' || runner.ss != 'ACTIVE'">
                                                    <button type="button" class=""> {{ $t('suspended','SUSPENDED')}} </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="marquee-show-msg" v-if=" bookmaker?.msg || (bookmaker?.msg && bookmaker?.msg != '') ">
                                    <div class="msgs" style="width: 100vw">
                                        <marquee>
                                            <i class="mdi mdi-email mr-1"></i> {{ bookmaker?.msg }}
                                        </marquee>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- fancy and premium tabs -->
                        <div class="match-and-unmatch-sec fancy-premium-tab-sec" id="fancy-sec">
                            <template v-if="!eventDetails?.is_exclusive">
                                <div class="tab-content" id="nav-tabContent">
                                    <div class="tab-pane fade show active tig-inner-fancy-tabs" role="tabpanel">
                                        <nav v-if="eventDetailHideSections && !eventDetailHideSections.includes('fancy_filters')">
                                            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                                <!-- <button  @click="selectFancyTab('Fancy')" class="nav-link" :class="{ 'active': selectedFancyTab == 'Fancy' }"
                                                        id="nav-fancy-tab" data-bs-toggle="tab" data-bs-target="#nav-fancy" type="button" role="tab" aria-controls="nav-fancy" aria-selected="true">Fancy</button> -->
                                                <!-- <button @click="selectFancyTab('otherMarkets')"
                                                    :class="{ 'active': (selectedFancyTab == 'otherMarkets') }"
                                                    class="nav-link" id="nav-other-market-tab" data-bs-toggle="tab" data-bs-target="#nav-other-market" type="button" role="tab" aria-controls="nav-other-market" aria-selected="false">Other Markets</button> -->
                                                <!-- <button @click="selectFancyTab('premiumFancy')"
                                                    :class="{ 'active': (selectedFancyTab == 'premiumFancy') }" class="nav-link" id="nav-premium-fancy-tab" data-bs-toggle="tab" data-bs-target="#nav-premium-fancy" type="button" role="tab" aria-controls="nav-premium-fancy" aria-selected="false">Premium Fancy</button> -->
                                                <template  v-for="(fData, index) in fancyCategories" :key="index">
                                                    <button v-if="(fData.value == 'premium_fancy' && fData.isPremiumAvailable) || fData.value != 'premium_fancy'"  @click="changeFancyCategory(fData)" class="nav-link" :class="((fData.value == selectedFancyCategory.value) && !isPremium) || (fData.value == 'premium_fancy' && isPremium)? 'active' : ''" :id="'nav-' + fData.value + '-tab'" data-bs-toggle="tab" type="button" role="tab" aria-selected="true">{{ $t(fData.key,fData.title) }}</button>
                                                </template>
                                            </div>
                                        </nav>
                                    </div>
                                </div>
                                <!-- Pinned Fancies -->
                                <div class="book-maker-section winner-cup" id="nav-fancy" role="tabpanel" aria-labelledby="nav-fancy-tab" tabindex="0" v-if="getPinnedFancies && getPinnedFancies?.length && isVisible == false && !isPremium && eventDetailHideSections && !eventDetailHideSections.includes('fancy_filters')">
                                    <div class="bok-maker-header-line">
                                        <div class="odds-title-row">
                                            <div class="odds-match-title-left">
                                                <div class="header-line-left">
                                                    <div class="booker-maker-winner-l"> <span>{{ $t('pin-fancy-market','Pin Fancy Market')}}</span> </div>
                                                </div>
                                            </div>
                                            <div class="odds-yesno-right">
                                                <div class="header-line-right"> 
                                                    <!-- <span class="back-lay">{{ $t('no-cap','NO')}}</span> 
                                                    <span class="back-lay">{{ $t('yes-cap','YES')}}</span>  -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="bg-light" v-for="(fancy, f_index) in getPinnedFancies" :key="f_index">
                                        <div class="fancy-odds-row">
                                            <div class="fancy-col-left">
                                                <div class="fancy_wishlist_title-left">
                                                    <div class="pined-fancy-btn">
                                                        <div class="pin-fav-btn">
                                                            <img loading="lazy" src="@/assets/images/star-selected.webp" v-if="pinnedFancies?.includes(fancy.mi)" style="cursor: pointer;" @click="pinUnpinFancy(fancy)" alt="star-selected"> 
                                                            <img loading="lazy" src="@/assets/images/star-dark.webp" alt="star-dark" v-else @click="pinUnpinFancy(fancy)"> 
                                                        </div>
                                                        <span>{{ fancy.mn }}</span>
                                                        <p class="back-lay-status" v-html="getRunnerBookHtml(fancy.mi, fancy.mi, 'f')"> </p>
                                                    </div>
                                                </div>
                                                <div class="fancy-ladder-row">
                                                    <div class="fancy-green-icon" v-if="fancy?.com">
                                                        <img src="@/assets/images/fancy-green-icon.svg" alt="fancy-green-icon" title="" />
                                                    </div>
                                                    <div class="ladder_icon">
                                                        <a @click="getfancyBook(fancy.mi)" class="match-stair" href="javascript:void(0);">
                                                            <img src="@/assets/images/ladder.png">
                                                        </a>
                                                    </div>
                                                    <div class="tiger-tooltip">
                                                        <i class="fa-solid fa-circle-info"></i>
                                                        <div class="tiger-info-sec">
                                                            <span>{{ $t('min-first-cap','Min')}}: {{ fancy.mins }}</span>
                                                            <span>{{ $t('max-first-cap','Max')}}: {{ fancy.ms }}</span>
                                                        </div>
                                                    </div>
                                                </div> 
                                            </div>
                                            <div class="fancy-col-right">
                                                <div class="back-odd-box">
                                                    <button type="button" class="light-pink-box1" @click="fancy?.rn && addBet(fancy, fancy, 'lay', 'fancy', 0, $event)"> <span>{{ fancy.rn ? fancy.rn : '' }}</span>
                                                        <span class="text-0" v-if="fancy.rn">{{ fancy.on ? fancy.on : '' }}</span> </button>
                                                    <button type="button" class="sky-blue-box1" @click="fancy?.ry && addBet(fancy, fancy, 'back', 'fancy', 0, $event)"> <span>{{ fancy.ry ? fancy.ry : '' }}</span>
                                                        <span class="text-0" v-if="fancy.ry">{{ fancy.oy ? fancy.oy : '' }}</span> </button>
                                                    <div class="suspended-match abonded-match" v-if="fancy.sn == 'BALL_RUN' || fancy.sn == 'SUSPEND'">
                                                        <button type="button" class=""> {{ $t('suspended','SUSPENDED')}} </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="marquee-show-msg" v-if="fancy?.msg || (fancy?.msg && fancy?.msg != '')">
                                            <div class="msgs" style="width: 100vw">
                                                <marquee>
                                                    <i class="mdi mdi-email mr-1"></i> {{ fancy?.msg }}
                                                </marquee>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Fancies -->
                                <div class="tab-content" id="nav-tabContent" v-if="!isPremium && eventDetailHideSections && !eventDetailHideSections.includes('fancy_filters')">
                                    <div class="tab-pane fade show active" id="nav-fancy" role="tabpanel" aria-labelledby="nav-fancy-tab">
                                        <div v-if="!filteredFancyList?.length">
                                            <div class="text-center w-100 py-3">
                                                {{$t("market-unavail","This Market Is Not Available Right Now")}}
                                            </div>
                                        </div>
                                        <template v-for="(fancyCat, fc_index) in filteredFancyList" :key="fc_index">
                                            <div class="book-maker-section winner-cup" v-if="fancyCat.fancies && fancyCat.fancies?.length">
                                                <div class="bok-maker-header-line">
                                                    <div class="odds-title-row">
                                                        <div class="odds-match-title-left">
                                                            <div class="header-line-left">
                                                                <div class="booker-maker-winner-l">
                                                                    <!-- <img loading="lazy" src="@/assets/images/star-dark.webp" alt=""> --><span>{{ fancyCat.title.toUpperCase() }}</span> </div>
                                                            </div>
                                                        </div>
                                                        <div class="odds-yesno-right">
                                                            <div class="header-line-right"> 
                                                                <!-- <span class="back-lay">{{ $t('no-cap','NO')}}</span> 
                                                                <span class="back-lay">{{ $t('yes-cap','YES')}}</span>  -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="bg-light" v-for="(fancy, f_index) in fancyCat.fancies" :key="f_index">
                                                    <div class="fancy-odds-row">
                                                        <div class="fancy-col-left">
                                                            <div class="fancy_wishlist_title-left">
                                                                <div class="pined-fancy-btn">
                                                                    <div class="pin-fav-btn">
                                                                        <img loading="lazy" src="@/assets/images/star-selected.webp" v-if="pinnedFancies?.includes(fancy.mi)" style="cursor: pointer;" @click="pinUnpinFancy(fancy)" alt="star-selected"> 
                                                                        <img loading="lazy" src="@/assets/images/star-dark.webp" alt="star-dark" v-else @click="pinUnpinFancy(fancy)">
                                                                    </div>
                                                                    <span>{{ fancy.mn }}</span>
                                                                    <p class="back-lay-status" v-html="getRunnerBookHtml(fancy.mi, fancy.mi, 'f')"> </p>
                                                                </div>
                                                               
                                                            </div>
                                                            <div class="fancy-ladder-row">
                                                                <div class="fancy-green-icon" v-if="fancy?.com">
                                                                    <img src="@/assets/images/fancy-green-icon.svg" alt="fancy-green-icon" title="" />
                                                                </div>
                                                                <div class="ladder_icon">
                                                                    <a @click="getfancyBook(fancy.mi)" class="match-stair" href="javascript:void(0);">
                                                                        <img src="@/assets/images/ladder.png">
                                                                    </a>
                                                                </div>
                                                                <div class="tiger-tooltip">
                                                                    <i class="fa-solid fa-circle-info"></i>
                                                                    <div class="tiger-info-sec">
                                                                        <span>{{ $t('min-first-cap','Min')}}: {{ fancy.mins }}</span>
                                                                        <span>{{ $t('max-first-cap','Max')}}: {{ fancy.ms }}</span>
                                                                    </div>
                                                                </div>
                                                            </div> 
                                                        </div>
                                                        <div class="fancy-col-right">
                                                            <div class="back-odd-box">
                                                                <button type="button" class="light-pink-box1" @click="fancy?.rn & addBet(fancy, fancy, 'lay', 'fancy', 0, $event)"> <span>{{ fancy.rn ? fancy.rn : '' }}</span>
                                                                    <span class="text-0" v-if="fancy.rn">{{ fancy.on ? fancy.on : '' }}</span> </button>
                                                                <button type="button" class="sky-blue-box1" @click="fancy?.ry && addBet(fancy, fancy, 'back', 'fancy', 0, $event)"> <span>{{ fancy.ry ? fancy.ry : '' }}</span>
                                                                    <span class="text-0" v-if="fancy.ry">{{ fancy.oy ? fancy.oy : '' }}</span> </button>
                                                                <div class="suspended-match abonded-match" v-if="fancy.sn == 'BALL_RUN' || fancy.sn == 'SUSPEND'">
                                                                    <button type="button" class=""> {{ $t('suspend','SUSPENDED')}} </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="marquee-show-msg" v-if="fancy?.msg || (fancy?.msg && fancy?.msg != '')">
                                                        <div class="msgs" style="width: 100vw">
                                                            <marquee>
                                                                <i class="mdi mdi-email mr-1"></i> {{ fancy?.msg }}
                                                            </marquee>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="(selectedFancyCategory.value != 'all' && fancyCat.fancies.length == 0 )">
                                                <div class="text-center w-100 py-3">
                                                    {{$t("market-unavail","This Market Is Not Available Right Now")}}
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </template>
                            <div v-if="isPremium && eventDetailHideSections && !eventDetailHideSections.includes('fancy_filters')" id="nav-premium-fancy" role="tabpanel" aria-labelledby="nav-premium-fancy-tab">
                                <!-- Content for Premium Fancy tab -->
                                <iframe class="fancy-iframe w-100" :src="premiumFancyUrl"></iframe>
                            </div>
                            <!-- tied Match -->
                            <div v-if="!eventDetails?.is_exclusive && eventDetailHideSections && !eventDetailHideSections.includes('othermarkets_filters') && otherMarkets && otherMarkets.length>0" id="nav-other-market" role="tabpanel" aria-labelledby="nav-other-market-tab">
                                <div class="book-maker-section" v-for="(market, m_index1) in otherMarkets" :key="m_index1">
                                    <template v-if="market.marketName != 'Match Odds' && isVisible == false">
                                        <div class="bok-maker-header-line">
                                            <div class="odds-title-row">
                                                <div class="odds-match-title-left">
                                                    <div class="header-line-left">
                                                        <div class="booker-maker-winner-l">
                                                            <!-- <img loading="lazy" src="@/assets/images/star-selected.webp" alt="">
                                                                <img loading="lazy" src="@/assets/images/star-dark.webp" alt=""> --><span> {{ market.marketName.toUpperCase() }} </span>
                                                            <template v-if="$auth.status">
                                                                <div class="btn cashout-btn" v-if="!cashoutMarketData[market.mid] || (cashoutMarketData[market.mid] && !cashoutMarketData[market.mid].value)">{{ $t('cashout','Cashout')}}</div>
                                                                <div class="btn cashout-btn" data-bs-toggle="modal" data-bs-target="#cashout-modal" v-html="cashoutMarketData[market.mid].value" @click="cashoutServiceCall(market, 'market')" v-else></div>
                                                            </template>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                                <div class="odds-yesno-right">
                                                    <div class="header-line-right"> 
                                                        <!-- <span class="back-lay">{{ $t('back','Back')}}</span> 
                                                        <span class="back-lay">{{ $t('lay','Lay')}}</span>  -->
                                                        <span>{{ $t('min-cap','MIN')}} : {{ market.min_stake_limit ? market.min_stake_limit : 0 }}</span> 
                                                        <span>{{ $t('max-cap','MAX')}} : {{ market.stake_limit ? market.stake_limit : 0 }}</span> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="bg-light" v-for="(runner, r_index) in market.runners" :key="r_index">
                                            <div class="odds-bookmaker-row">
                                                <div class="odds-bookmaker-col-left">
                                                    <div class="runner-city text-truncate"> 
                                                        <span>{{ runner.runner_name }}</span>
                                                        <span class="back-lay-status" v-html="getRunnerBookHtml(market.mid, runner.sid, 'm')"> </span> 
                                                    </div>
                                                </div>
                                                <div class="odds-bookmaker-col-right">
                                                    <div class="back-odd-box open-bet-box">
                                                        <button type="button" class="back1" @click="runner.ex.b?.[2]?.p && addBet(market, runner, 'back', 'market', r_index, $event)"> <span>{{ runner.ex.b?.[2] ? runner.ex.b?.[2].p : '' }}</span>
                                                                <span class="text-0" v-if="runner.ex.b?.[2]">{{ runner.ex.b?.[2] ? runner.ex.b?.[2].s : ''
                                                            }}</span> </button>
                                                        <button type="button" class="back2" @click="runner.ex.b?.[1]?.p && addBet(market, runner, 'back', 'market', r_index, $event)"> <span>{{ runner.ex.b?.[1] ? runner.ex.b?.[1].p : '' }}</span>
                                                                <span class="text-0" v-if="runner.ex.b?.[1]">{{ runner.ex.b?.[1] ? runner.ex.b?.[1].s : ''
                                                            }}</span> </button>
                                                        <button type="button" class="sky-blue-box1" @click="runner?.ex.b?.[0]?.p && addBet(market, runner, 'back', 'market', r_index, $event)"> <span>{{ runner.ex.b?.[0] ? runner.ex.b?.[0].p : '' }}</span>
                                                            <span class="text-0" v-if="runner.ex.b?.[0]">{{ runner.ex.b?.[0] ? runner.ex.b?.[0].s : ''
                                                            }}</span> </button>
                                                        <button type="button" class="light-pink-box1" @click="runner?.ex?.l?.[0].p && addBet(market, runner, 'lay', 'market', r_index, $event)"> <span>{{ runner.ex.l?.[0] ? runner.ex.l?.[0].p : '' }}</span>
                                                            <span class="text-0" v-if="runner.ex.l?.[0]">{{ runner.ex.l?.[0] ? runner.ex.l?.[0].s : ''
                                                            }}</span> </button>
                                                        <button type="button" class="lay1" @click="runner?.ex.l?.[1].p && addBet(market, runner, 'lay', 'market', r_index, $event)"> <span>{{ runner.ex.l?.[1] ? runner.ex.l?.[1].p : '' }}</span>
                                                            <span class="text-0" v-if="runner.ex.l?.[1]">{{ runner.ex.l?.[1] ? runner.ex.l?.[1].s : ''
                                                            }}</span> </button>
                                                        <button type="button" class="lay2" @click="runner?.ex.l?.[2]?.p && addBet(market, runner, 'lay', 'market', r_index, $event)"> <span>{{ runner.ex.l?.[2] ? runner.ex.l?.[2].p : '' }}</span>
                                                            <span class="text-0" v-if="runner.ex.l?.[2]">{{ runner.ex.l?.[2] ? runner.ex.l?.[2].s : ''
                                                            }}</span> </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <div class="marquee-show-msg" v-if="market?.msg || (market?.msg && market?.msg != '')">
                                        <div class="msgs" style="width: 100vw">
                                            <marquee><i class="mdi mdi-email mr-1"></i> {{
                                                market?.msg }}
                                            </marquee>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="Object.keys(eventDetails)?.length && isVisible == false">
                        <NoDataFound />
                    </template>
				</div>
				<BetList :openBetData="openBets" :eventDetails="eventDetails" />
            </div>
		</div>
	</div>
	<!-- betslip -->
	<div class="open-bets-details-model">
		<div class="modal fade" id="bet-slip-modal" aria-hidden="true" aria-labelledby="bet-slip-modalLabel" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-body">
						<div class="back-placed-bets-sec">
							<div class="betslip-backlay-btn">
								<div class="betslip-accept-odds-left">
									<div class="accept-con-odd" v-if="betDetails.bet_type != 'fancy'">
										<div class="form-check form-switch">
											<input class="form-check-input" @change="changeAcceptOdds()" v-model="betDetails.accept_any_odds" type="checkbox" id="flexSwitchCheckDefaults">
											<label class="form-check-label" for="flexSwitchCheckDefaults">{{ $t('accept-any-odds','Accept any odds')}}</label>
										</div>
									</div>
									<div class="runner-teamname-betslip back-lay-status"> 
                                        <span class="team-name-betslip">{{ betDetails.runner_name }}</span> 
                                        <!-- <span v-html="getRunnerBookHtml(betDetails.bet_type != 'bookmaker' ? betDetails?.market?.mid : betDetails?.market?.mi, betDetails.bet_type != 'bookmaker' ? betDetails?.runner?.sid : betDetails?.runner?.si, betDetails.bet_type != 'bookmaker' ? 'm' : 'b')"></span>  -->
                                    </div>
								</div>
								<div class="betslip-accept-odds-right">
									<div class="back-lay-palced-box-sec" v-if="betDetails.bet_type == 'market'">
                                        <button type="button" class="sky-blue-box1" :disabled="loader || clickBetActive" @click="addBet(betDetails.market, betDetails.runner, 'back', betDetails.bet_type, betDetails.rIndex, $event)" v-if="betDetails.runner?.ex?.b[0]?.p"> <span>{{ betDetails.runner?.ex?.b[0]?.p }}</span>
                                            <span class="text-0" v-if="betDetails.runner?.ex?.b[0]?.s">{{ betDetails.runner?.ex?.b[0]?.s }}</span> </button>
										<button type="button" class="light-pink-box1" :disabled="loader || clickBetActive" @click="addBet(betDetails.market, betDetails.runner, 'lay', betDetails.bet_type, betDetails.rIndex, $event)" v-if="betDetails.runner?.ex?.l[0]?.p"> <span>{{ betDetails.runner?.ex?.l[0]?.p }}</span>
										<span class="text-0" v-if="betDetails.runner?.ex?.l[0]?.s">{{ betDetails.runner?.ex?.l[0]?.s }}</span> </button>
										
									</div>
									<div class="back-lay-palced-box-sec" v-if="betDetails.bet_type == 'bookmaker'">
                                        <button type="button" class="sky-blue-box1" :disabled="loader || clickBetActive" @click="addBet(betDetails.bookmaker, betDetails.runner, 'back', betDetails.bet_type, betDetails.rIndex, $event)" v-if="betDetails.runner?.b"> <span>{{ betDetails.runner?.b }}</span>
                                            <span class="text-0">{{betDetails?.market?.ms}}</span> </button>
										<button type="button"  class="light-pink-box1" :disabled="loader || clickBetActive" @click="addBet(betDetails.bookmaker, betDetails.runner, 'lay', betDetails.bet_type, betDetails.rIndex, $event)" v-if="betDetails.runner?.l"> <span>{{ betDetails.runner?.l }}</span>
										<span class="text-0">{{betDetails?.market?.ms}}</span> </button>                                                                                                                                            
										
									</div>
									<div class="back-lay-palced-box-sec" v-if="betDetails.bet_type == 'fancy'">
                                        <button type="button" class="light-pink-box1" :disabled="loader || clickBetActive" @click="addBet(betDetails.fancy, betDetails.runner, 'back', betDetails.bet_type, betDetails.rIndex, $event)"> <span>{{ betDetails.runner?.rn ? betDetails.runner?.rn :'-' }}</span>
                                        <span class="text-0" v-if="betDetails.runner?.rn">{{ betDetails.runner?.on ? betDetails.runner?.on : '' }}</span> </button>
										<button type="button" class="sky-blue-box1" :disabled="loader || clickBetActive" @click="addBet(betDetails.fancy, betDetails.runner, 'lay', betDetails.bet_type, betDetails.rIndex, $event)"> <span>{{ betDetails.runner?.ry }}</span>
										<span class="text-0">{{ betDetails.runner?.oy }}</span> </button>
									</div>
								</div>
							</div>
						</div>
						<div class="placed-bets-main-body" :class="betDetails.selection_type == 'lay' ? 'pink-bg' : ''">
							<div class="container-fluid">
								<div class="row">
									<div class="col-12">
										<div class="rate-stake-l">
											<div class="bet-slip-top-flex">
                                                <div class="increment-decrement-sec">
                                                    <div class="value-button" id="decrease" :class="betDetails.bet_type != 'market' ? 'd-none' : ''" @click="oddsMinus">-</div>
                                                    <div class="select-digit">
                                                        <input type="number" class="form-control" id="number" readonly v-model="betDetails.odds" :class="betDetails.bet_type != 'market' ? 'input-disabled' : ''" :disabled="betDetails.bet_type != 'market' && loader"> </div>
                                                    <div class="value-button" id="increase" :class="betDetails.bet_type != 'market' ? 'd-none' : ''" @click="oddsPlus">+</div>
                                                </div>
                                                <div class="select-digit">
                                                    <input type="tel" class="form-control green-clr-input text-center" id="number-r" :disabled="loader || clickBetActive" v-model="betDetails.stake" @keyup="calculationOfProfitLoss" @input="formatStakes" @keypress="checkForStakes($event)" placeholder="Stake"> 
                                                    <div class="tig-reset-btn"> 
                                                        <a @click="clearStake()" class=""><img src="@/assets/images/reset_btn.svg"></a> 
                                                    </div>
                                                </div>
                                                
											</div>
											<div class="placed-grid-main-container" v-if="chips">
												<div class="placed-small-box">
													<button type="button" :disabled="loader || clickBetActive" @click="setStakeValue(chips.chip_val_1)"> {{ chips.chip_name_1 }} </button>
												</div>
												<div class="placed-small-box">
													<button type="button" :disabled="loader || clickBetActive" @click="setStakeValue(chips.chip_val_2 ? chips.chip_val_2 : chips.chip_val_1)"> {{ chips.chip_name_2 ? chips.chip_name_2 : chips.chip_name_1 }} </button>
												</div>
												<div class="placed-small-box">
													<button type="button" :disabled="loader || clickBetActive" @click="setStakeValue(chips.chip_val_3 ? chips.chip_val_3 : chips.chip_val_1)"> {{ chips.chip_name_3 ? chips.chip_name_3 : chips.chip_name_1 }} </button>
												</div>
												<div class="placed-small-box">
													<button type="button" :disabled="loader || clickBetActive" @click="setStakeValue(chips.chip_val_4 ? chips.chip_val_4 : chips.chip_val_1)"> {{ chips.chip_name_4 ? chips.chip_name_4 : chips.chip_name_1 }} </button>
												</div>
												<div class="placed-small-box">
													<button type="button" :disabled="loader || clickBetActive" @click="setStakeValue(chips.chip_val_5 ? chips.chip_val_5 : chips.chip_val_1)"> {{ chips.chip_name_5 ? chips.chip_name_5 : chips.chip_name_1 }} </button>
												</div>
												<div class="placed-small-box">
													<button type="button" :disabled="loader || clickBetActive" @click="setStakeValue(chips.chip_val_6 ? chips.chip_val_6 : chips.chip_val_1)"> {{ chips.chip_name_6 ? chips.chip_name_6 : chips.chip_name_1 }} </button>
												</div>
												<div class="placed-small-box">
													<button type="button" :disabled="loader || clickBetActive" @click="setStakeValue(chips.chip_val_7 ? chips.chip_val_7 : chips.chip_val_1)"> {{ chips.chip_name_7 ? chips.chip_name_7 : chips.chip_name_1 }} </button>
												</div>
												<div class="placed-small-box">
													<button type="button" :disabled="loader || clickBetActive" @click="setStakeValue(chips.chip_val_8 ? chips.chip_val_8 : chips.chip_val_1)"> {{ chips.chip_name_8 ? chips.chip_name_8 : chips.chip_name_1 }} </button>
												</div>
											</div>
											<div class="model-close-cmn-btn dis-flex-betslip "> <a href="javascript:void(0);" data-bs-dismiss="modal" :disabled="loader || clickBetActive" @click="this.renderBetSlip = false, cancleBetSlip()" :class="{ 'lay-cancel-bet-btn': betDetails.selection_type == 'lay' }">
                                                    {{ $t('cancel','Cancel')}}
                                                </a> <a href="javascript:void(0);" class="placed-bet-btn" :class="{ 'lay-place-bet-btn': betDetails.selection_type == 'lay' }" @click="saveBets()">{{ $t('place-bet-cap','PLACE BET')}}
                                                </a> </div>
											<div class="dis-flex-betslip min-max-value-betslip">
                                                <span>{{ $t('min-cap','MIN')}} : {{ betDetails.min_stake }}</span> 
                                                <span>{{ $t('max-cap','MAX')}} : {{ betDetails.max_stake }}</span>
                                            </div>
											<div class="runner-team-name-betslip" v-if="betDetails?.market?.runners && betDetails.market.runners.length > 0">
												<div class="runner-city text-truncate">
													<span v-for="(runner,rIndex) in betDetails.market.runners" :key="rIndex">{{ runner?.runner_name }}</span> 
                                                </div>
												<div class="runner-city text-truncate text-right"> 
                                                    <span v-for="(runner,rIndex) in betDetails.market.runners" :key="rIndex" v-html="getRunnerBookHtml(betDetails.bet_type != 'bookmaker' ? betDetails?.market?.mid : betDetails?.market?.mi, betDetails.bet_type != 'bookmaker' ?
                                                        runner?.sid : runner?.si, betDetails.bet_type != 'bookmaker' ? 'm' : 'b')">
                                                    </span> 
                                                </div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- fancybook modal -->
	<div class="modal fade" id="fancyBookModal" aria-hidden="true" aria-labelledby="placed-bet11Label" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="staticBackdropLabel">
                        {{ $t('fancy-book','Fancy Book')}}
                    </h5>
					<!-- <button type="button" ref="close_button" class="btn-close" data-bs-dismiss="modal"
                        aria-label="Close"></button> -->
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"><span class="fa-solid fa-times"></span></button>
				</div>
				<div class="modal-body">
					<div class="responsive-table fancybook-table">
						<table class="table">
							<thead>
								<tr class="text-center">
									<th scope="col">{{ $t('position','Position')}}</th>
									<th scope="col"></th>
									<th scope="col">{{ $t('profit-loss','Profit / Loss')}}</th>
								</tr>
							</thead>
							<tbody>
								<template v-for="(fancyBookPosition, fBpI) in fancyBookPositions" :key="fBpI">
									<tr class="table-profit text-center" :class="isNegative(fancyBookPosition.result) ? 'table-loss' : ''">
										<td>{{ fancyBookPosition.odds }}</td>
										<td><span class="t-p-l-arrow"><i class="fa-solid fa-arrow-right"></i></span> </td>
										<td>{{ fancyBookPosition.result }}</td>
									</tr>
								</template>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- Cashout Modal -->
	<div class="modal fade cashout-modal" id="cashout-modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
		<div class="modal-dialog">
			<div class="modal-content">
                <div class="modal-header border-blow">
                    <h5>{{ $t('cashout','Cashout')}}</h5> 
                    <button type="button" @click="closeCashout()" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        <img loading="lazy" src="@/assets/images/close-btn.webp" alt=""> 
                    </button>
                </div>
				<div class="modal-body">
					<div class="modal-banner-sec">
						<div class="modal-banner-img"> <img loading="lazy" src="@/assets/images/cashout-icon.webp" alt="cashout-icon"> </div>
						<div class="live-but-sub-con"> <span>{{ $t('are-you-sure-want-to-cash-out','Are you sure want to cash out?')}}</span> </div>
					</div>
                    <div class="modal-footer border-0">
                        <button ref="closeCashoutModal" data-bs-dismiss="modal" class="btn cancle-but" @click="closeCashout()">{{ $t('no','No')}}</button>
                        <button @click="callforCashout()" class="btn place-but">{{ $t('yes','Yes')}}</button>
                    </div>
				</div>
			</div>
		</div>
	</div>
	<!-- Run Position Modal -->
	<div class="modal fade run-position-modal" id="run-position-modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
                <div class="modal-header border-blow">
                    <h5>Fancy Book</h5> 
                    <button type="button" @click="closeCashout()" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        <img loading="lazy" src="@/assets/images/close-btn.webp" alt=""> 
                    </button>
                </div>
                <div class="modal-body">
                    <div class="tiger-run-position-table">
                        <table>
                            <tr>
                                <!-- <th>Run</th>
                                <th>Position</th> -->
                                <th>{{ $t('position','Position')}}</th>
                                <th>{{ $t('profit-loss','Profit / Loss')}}</th>
                            </tr>
                            <!-- <tr>
                                <td>{{getValue.lay_run}}</td>
                                <td class="profit-color">{{ getValue.lay_position }}</td>
                            </tr>
                            <tr>
                                <td>{{ getValue.back_run }}</td>
                                <td class="loss-color">{{ getValue.back_position }}</td>
                            </tr> -->
                            <template v-if="fancyBookPositions?.length"> 
                                <template v-for="(fancyBookPosition, fBpI) in fancyBookPositions" :key="fBpI">
                                    <tr>
                                        <td> {{ fancyBookPosition.odds }}</td>
                                        <!-- <td><span class="t-p-l-arrow"><i class="fa-solid fa-arrow-right"></i></span>
                                        </td> -->
                                        <td class="profit-color" :class="isNegative(fancyBookPosition.result) ? 'loss-color' : ''"> {{ fancyBookPosition.result }}</td>
                                    </tr>
                                </template>
                            </template>
                            <tr v-else>
                                <td colspan="2">{{ $t('loading','Loading')}}</td>
                            </tr>
                        </table>
                    </div>
                </div>
			</div>
		</div>
	</div>
	<!-- hide show filter data -->
	<div class="modal fade bonus-point-modal" id="filterModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog modal-md modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header border-blow">
                    <div class="filter_title_header">
                        <h3>{{ $t('hide-show-filter','Hide/Show Filter')}}</h3>
                        <button ref="close_btn" type="button" class="thm-but" @click="() => { this.selectedPageSections = []; }">{{ $t('clear','Clear')}}</button>
                    </div>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref="eventDetailFilterModal" @click="() => { this.selectedPageSections = this.eventDetailHideSections; }"> <img loading="lazy" src="@/assets/images/close-btn.webp" alt="close-btn" class="filter-close-modal" /> </button>
				</div>
				<div class="modal-body p-body filtered-body">
					<p class="check-blow">{{ $t('hide-show-check-below','Hide/Show Check Below')}}</p>
					<div class="filter-box">
						<div class="row">
							<div class="col-6" v-for="(pageFilter, pIndex) in pageSections" :key="pIndex">
								<div class="filter-btn">
									<div class="form-check">
										<input class="form-check-input" v-model="selectedPageSections" type="checkbox" :id="'pageFiltershow_full_screen'+ pageFilter.slug" :value="pageFilter.slug" />
										<label class="form-check-label" :for="'pageFiltershow_full_screen' + pageFilter.slug">{{ $t(pageFilter.key , pageFilter.title) }}</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer border-0 apply-filter-btn">
					<button type="button" class="btn btn-gradient" data-bs-dismiss="modal" @click="pageFilterApply()">{{ $t('apply','Apply')}}</button>
				</div>
			</div>
		</div>
	</div>
	<LowBalanceModal />
</template>

<script>
import { mapGetters } from 'vuex';
import socketService from "../../../socket/sport-socket-service";
import { defineAsyncComponent } from 'vue';
import cashout from '../services/cashout';
import { checkForPremiumFancyEvent } from '@/shared/services/eventLocks'
export default {
    name: 'SportsEventDetail',
    extends: cashout,
    components: {
        BetList: defineAsyncComponent(() => import('../components/BetList.vue')),
        NoDataFound: defineAsyncComponent(() => import('@/shared/components/no-data/NoDataFound.vue')),
        LowBalanceModal: defineAsyncComponent(() => import('../components/LowBalanceModal.vue')),
    },
    data() {
        return {
            // type: null,
            // favMatchOdds: null,
            selectedPageSections: [],
            pageSections: [
                { title: 'Show Full Screen', slug: 'show_full_screen',key: 'show-full-screen' },
                { title: 'Hide Match Odds', slug: 'match_odds' ,key: 'hide-match-odds'},
                { title: 'Hide Bookmakers', slug: 'bookmakers' ,key: 'hide-bookmakers'},
                { title: 'Hide Other Markets', slug: 'othermarkets_filters', key: 'hide-othermarkets-tabs' },
                { title: 'Hide Fancy Tabs', slug: 'fancy_filters' ,key: 'hide-fancy-tabs' },
            ],
            displayLoader: false,
            getValue: {},
            pageNo: 1,
            showMobileBet:false,
            activeOpenBetType: 'main_market',
            showScoreCard: false,
            showTv: false,
            loader: false,
            isVisible: false,
            event_id: this.$route.params.event_id,
            eventDetails: [],
            upcommingEvents: [],
            matchOddsData: [],
            mainMarketRunners: [],
            bookmakerData: [],
            fancyData: [],
            openBets: {},
            betDetails: {},
            marketBookAndExposure: null,
            current_score_tab: 'scoreboard',
            socketIoData: [],
            fancyCategories: {},
            fancyCategoriesData: [],

            current_bet: {
                stake: '',
                bet_user_guid: '',
                accept_any_odds: false
            },
            renderBetSlip: false,
            screenSize: window.innerWidth,
            mobileView: 1023,
            betCloseSetTimeOut: null,
            fancyBookPositions: [],
            chips: this.$store?.getters?.chips,
            showEditStake: false,
            betSlipModal: '',
            intervalTimer: null,
            selectedFancyCategory: {
                title: 'All',
                value: 'all'
            },
            fancyCategories: [
                {
                    title: 'Fancy',
                    value: 'all',
                    key: 'fancy'
                },
                {
                    title: 'Premium Fancy',
                    value: 'premium_fancy',
                    key: 'premium-fancy',
                    isPremiumAvailable: this.checkForPremiumFancyEvent()
                },

                {
                    title: 'Line Markets',
                    value: 'line_markets',
                    key: 'line-markets',
                    fancies: []
                },

                {
                    title: 'Session Markets',
                    value: 'session_markets',
                    key: 'session-markets',
                    fancies: []
                },

                {
                    title: 'Ball By Ball',
                    value: 'ball_by_ball',
                    key: 'ball-by-ball',
                    fancies: []
                },

                {
                    title: 'Fall Of Wicket',
                    value: 'fall_of_wicket',
                    key: 'fall-of-wicket',
                    fancies: []
                },

                {
                    title: 'Player Market',
                    value: 'other_markets',
                    key: 'player-market',
                    fancies: []
                },

                {
                    title: 'Meter Markets',
                    value: 'meter_markets',
                    key: 'meter-markets',
                    fancies: []
                },

                {
                    title: 'Khado Markets',
                    value: 'khado_markets',
                    key: 'khado-markets',
                    fancies: []
                },

                {
                    title: 'Odd Event Markets',
                    value: 'odd_even_markets',
                    key: 'odd-event-markets',
                    fancies: []
                },

                {
                    title: 'Advance Market',
                    value: 'total_advance',
                    key: 'advance-market',
                    fancies: []
                },

            ],
            pinnedFancies: null,
            cashoutDetails: {},
            CashoutLoader: false,
            cashoutMarketData: {},
            cashoutTimeOut: null,
            selectedFancyTab: 'Fancy',
            init: true,
            premiumFancyUrl: null,
            isPremium: false,
            currentTab: 'market',
            cashoutSlipCloseTime: null,
            averageOdds: false
        }
    },
    computed: {
        ...mapGetters({
            eventDetailHideSections: 'eventDetailHideSections',
            stateUser:'stateUser',
            favouriteGames: 'favouriteGames'
        }),
        filteredOpenBets() {
            if (this.openBets?.length) {
                const matchingMatchId = this.eventDetails?.eventId;
                return this.openBets?.filter(bet => bet.event_id == matchingMatchId)[0] ?? {}
            }
            return {}
        },
        filteredFancyList() {
            let response = [];
            for (let fancyCat of this.fancyCategories) {
                fancyCat.fancies = [];
            }
            if (this.selectedFancyCategory != null) {
                if (this.selectedFancyCategory.value == 'all') {
                    if (this.fancyData && this.fancyData.ml) {
                        response = [...this.fancyCategories];
                        for (let fancy of this.fancyData.ml) {
                            let fancyCat = response.find(fc => fc.value == fancy.cat);
                            if (!fancyCat) continue;
                            fancyCat.fancies.push(fancy);
                        }
                    }
                } else {
                    if (this.fancyData && this.fancyData.ml) {
                        this.selectedFancyCategory.fancies = this.fancyData.ml.filter(fc => fc.cat == this.selectedFancyCategory.value);
                        response = [this.selectedFancyCategory, ...response];
                    }
                }
            }
            return response;
        },
        otherMarkets() {
            let eventMarkets = [];
            if (this.matchOddsData && this.matchOddsData?.length) {
                eventMarkets = this.matchOddsData.filter((m) => (m.marketName != 'Match Odds' && m.marketName != 'Who Will Win The Match?')).sort((a, b) => {
                    return a.marketName.localeCompare(b.marketName) // Sort Ascending 
                });
            }
            return eventMarkets;
        },
        getPinnedFancies() {
            let response = [];
            if (!(this.fancyData && this.fancyData.ml && this.fancyData.ml?.length) || !(this.pinnedFancies && this.pinnedFancies?.length)) {
                return response;
            }
            response = this.fancyData.ml.filter(f => {
                return this.pinnedFancies.includes(f.mi);
            })
            return response;
        },
        getClickBetValue() {
            return this.$store.getters.clickBetValue ? [...this.$store.getters.clickBetValue] : null;
        },
        clickBetActive() {
            return this.$store.getters.clickBetActive;
        },
        getBetandAvgOdds() {
            if (!this.filteredOpenBets) {
                return [];
            }

            if (this.averageOdds) {
                let averageData = [];

                ['main_market', 'bookmakers', 'fancies'].forEach((item) => {
                    let matchData = {
                        market: item,
                        lay: {
                            odds: 0,
                            stake: 0,
                            pl: 0,
                            betCount: 0
                        },
                        back: {
                            odds: 0,
                            stake: 0,
                            pl: 0,
                            betCount: 0
                        }
                    };

                    if (this.filteredOpenBets[item]) {
                        for (let i = 0; i < this.filteredOpenBets[item].length; i++) {
                            let currbetType = this.filteredOpenBets[item][i];
                            let selectionType = currbetType.selection_type;

                            if (matchData[selectionType]) {
                                matchData[selectionType].odds += parseFloat(currbetType.odds);
                                matchData[selectionType].stake += parseFloat(currbetType.stake);
                                matchData[selectionType].pl += parseFloat(currbetType.pl);
                                matchData[selectionType].betCount++;
                            }
                        }
                    }

                    ['lay', 'back'].forEach(selectionType => {
                        let betType = matchData[selectionType];
                        if (betType.betCount > 0) {
                            betType.odds /= betType.betCount;
                        }

                        betType.odds = parseFloat(betType.odds.toFixed(2));
                        betType.stake = parseFloat(betType.stake.toFixed(2));
                        betType.pl = parseFloat(betType.pl.toFixed(2));
                    });

                    averageData.push(matchData);
                });
                return averageData;
            } else {
                return [
                    ...this.filteredOpenBets.main_market,
                    ...this.filteredOpenBets.bookmakers,
                    ...this.filteredOpenBets.fancies
                ].sort((a, b) => b.bet_timestamp_date - a.bet_timestamp_date);
            }
        }
    },
    created() {
        this.getEventDetails()
        this.receiveMessage();
        this.setPinnedFancy();
        this.selectedPageSections = this.eventDetailHideSections;
    },
    mounted() {
        // this.favMatchOdds = JSON.parse(localStorage.getItem('fav_sports_list'))
        this.clickBetCheck = this?.$store?.getters?.clickBetCheck
        let user = this.$store.getters.stateUser;
        this.intervalTimer = setInterval(() => {
            this.getEventDetails()
        }, 30000)
        // low balence modal popup initializatiion
        setTimeout(()=>{
            if (this.$auth.status && this.$auth?.user?.balance < 100 && this.$siteSettings?.data?.business_type == 2) {
                this.toggleLowBalanceModal();
                setInterval(()=>{this.toggleLowBalanceModal()}, 600000)
            }
        },2000)
        setTimeout(() => {
            if (this.$auth?.status && this.eventDetails?.hasPremiumFancy && !this.eventDetailHideSections.includes('fancy_filters') && (!this.eventDetails?.hasFancy || (this.eventDetails?.hasFancy && !this.fancyData?.ml?.length)) && this.checkForPremiumFancyEvent()) {
                this.selectFancyTab('premiumFancy');
            }
        }, 800)
        socketService.emit("sub", this.event_id);
        // this.betSlipModal = new Modal(document.getElementById('bet-slip-modal'));
        // this.getClickBetValue = this.$store.getters.clickBetValue ? [...this.$store.getters.clickBetValue] : null;
    },
    methods: {
        checkForPremiumFancyEvent,
        selectFancyTab(category) {
            this.cancleBetSlip();
            this.selectedFancyTab = category;
            if (category != 'premiumFancy') return;
            this.isPremium = true
            let { sport_radar_sport_id, sportsradar_id, sportId, eventId } = this.eventDetails;
            let ids = {
                sportId: sport_radar_sport_id ? `sr:sport:${sport_radar_sport_id}` : sportId,
                eventId: sportsradar_id && sportsradar_id !== '0' ? `sr:match:${sportsradar_id}` : eventId,
            };
            if (this.$auth.status) {
                this.loading = true;
                this.$apiCall('get', 'GET_PREMIUM_FANCY_URL', null, 'user', { sportId: ids.sportId, eventId: ids.eventId }).then(response => {
                    this.premiumFancyUrl = response.data.premium_url;
                    this.loading = false;
                }).catch(error => {
                    if (error) {
                        this.loading = false;
                        this.showErrorModalFunc(error.data.message);
                    }
                });
            } else {
                this.showErrorModalFunc(this.$t('login-access-pre-fancy','Please Log In to access premium fancy!'));
            }
        },
        checkForStakes(event) {
            // Prevent input of the letter 'e'
            if (event.key.toLowerCase() === 'e') {
                event.preventDefault();
            }
            if (event.key === '-' || event.key === '+' || event.key === '.') {
                event.preventDefault();
            }
        },
        maxStakes(){
            var value = this.betDetails.stake
            if (value !== '' && parseInt(value) > this.betDetails.max_stake) {
                this.betDetails.stake = this.betDetails.max_stake;
            }
        }, 
        formatStakes() {
            this.maxStakes()
            // Convert the input to a string
            let stringValue = this.betDetails.stake.toString();
            stringValue = stringValue.replace(/[^0-9]/g, '');
            stringValue = stringValue.replace(/[+-]/g, ''); // Replace '+' and '-' characters with an empty string
            // Convert the sanitized string back to a number
            this.betDetails.stake = stringValue === '' ? null : parseInt(stringValue);
        },
        pageFilterApply() {
            this.$store.dispatch('seteventDetailHideSections', this.selectedPageSections);
            if ((this.eventDetailHideSections.includes('othermarkets_filters')) || (this.eventDetailHideSections.includes('premiumfancy_filters') && this.selectedFancyTab == 'premiumFancy')) {
                this.selectedFancyTab = 'Fancy'
            }
            this.$refs.eventDetailFilterModal.click();
        },
        getRunsAndPosition(fancy, f_index) {
            this.getValue.lay_run = fancy.rn;
            this.getValue.lay_position = fancy.mins
            this.getValue.back_run = fancy.ry;
            this.getValue.back_position = fancy.oy;
        },
        pinUnpinFancy(fancy) {
            let user = this.$store.getters.stateUser;
            if (!this.$auth.status || !user) {
                this.showErrorModalFunc(this.$t('login-to-place-bets','Please login to place the bets!'));
                return
            }
            if (!user.pinnedFancies) {
                user.pinnedFancies = [];
                user.pinnedFancies.push(fancy.mi);
                // document.querySelector("#fancy-tab").scrollIntoView({ behavior: "smooth" });
                this.showSuccessModalFunc(this.$t('Added-fancy','Added this fancy under Pin Fancy Market'));
            } else {
                if (user.pinnedFancies.includes(fancy.mi)) {
                    user.pinnedFancies.splice(user.pinnedFancies.indexOf(fancy.mi), 1);
                    this.showSuccessModalFunc(this.$t('removed-from-pin-fancy','Removed from Pin Fancy Market!'));
                } else {
                    user.pinnedFancies.push(fancy.mi);
                    this.showSuccessModalFunc(this.$t('Added-fancy','Added this fancy under Pin Fancy Market'));
                }
            }
            this.pinnedFancies = user.pinnedFancies;
            this.$store.dispatch('setUser', user);

        },
        setPinnedFancy() {
            let user = this.$store.getters.stateUser;
            if (user && user.pinnedFancies) {
                this.pinnedFancies = user.pinnedFancies;
            }
        },
        receiveMessage() {
            window.addEventListener('message', event => {
                var iframe = document.getElementById('sportradar_score');
                if (iframe != null && event.data.height != 0) {
                    iframe.style.height = event.data.height + 'px';
                }
            });
        },
        betSlip() {
            this.currentTab = 'bet';
            this.showScoreCard = false;
            this.showTv = false;
            var liveTvPin = document.getElementById("live-tv-pin");
            var fancySec = document.getElementById("fancy-sec");
            if (!this.isVisible) {
                this.getOpenBetsServiceCall()
                this.isVisible = true
                var bets = document.getElementById('bets-detail');
                if (bets.style.display === 'none' || bets.style.display === '') {
                    bets.style.display = 'block';
                    liveTvPin.style.display = "none";
                    fancySec.style.display = "none";
                    // this.showScoreCard=false;
                }
                // else {
                //     bets.style.display = "none"
                //     liveTvPin.style.display = "block";
                //     // this.showScoreCard=true;
                // }
            }
            // $(".bets-details-in-mobile").toggle();
            // $(".book-maker-section").css("display", "none");
        },
        marketShow() {
            this.currentTab = 'market';
            if (this.isVisible) {
                var bets_details_in_mobile = document.getElementById('bets-detail')
                var fancySec = document.getElementById("fancy-sec");

                if ( bets_details_in_mobile.style.display === "none" || bets_details_in_mobile.style.display === "" || fancySec.style.display === "none" || fancySec.style.display === "") {
                    fancySec.style.display = "block";
                    this.isVisible = false
                    bets_details_in_mobile.style.display = "none";
                } else {
                    bets_details_in_mobile.style.display = "none";
                    this.isVisible = false
                }
            }
        },
        toggleTv() {
            this.currentTab = 'market';
            this.showTv = !this.showTv
            var bets = document.getElementById('bets-detail');
            var liveTvPin = document.getElementById("live-tv-pin");
            var fancySec = document.getElementById("fancy-sec");
            if (
                liveTvPin.style.display === "none" ||
                liveTvPin.style.display === "" ||
                fancySec.style.display === "none" ||
                fancySec.style.display === ""
            ) {
                liveTvPin.style.display = "block";
                fancySec.style.display = "block";
                this.isVisible = false
                bets.style.display = "none";
            } else {
                liveTvPin.style.display = "none";
                this.isVisible = false
            }
        },
        toggleScoreCard() {
            this.showScoreCard = !this.showScoreCard;
            this.marketShow()
        },
        getEventDetails() {
            this.loading = true;
            this.$apiCall('get', 'GET_MATCH_DETAILS', null, 'sports', { event_id: this.event_id }).then(response => {
                this.loading = false;
                if (response) {
                    if (response.status == 200 && response.data.success == true) {
                        this.eventDetails = response.data.data.match
                        this.upcommingEvents = response.data.data.upcoming
                        this.matchOddsData = response.data.data.match.matchOddData.sort((a, b) => {
                            return a.marketName.localeCompare(b.marketName) // Sort Ascending 
                        });
                        this.bookmakerData = response.data.data.match.bookmakerOddData
                        this.fancyData = response.data.data.match.fancyOddData
                        for (var i = 0; i < this.matchOddsData?.length; i++) {
                            for (var j = 0; j < this.matchOddsData[i].runners?.length; j++) {
                                for (var k = 0; k < this.matchOddsData[i].runnerName?.length; k++) {
                                    if (this.matchOddsData[i].runners[j].sid == this.matchOddsData[i].runnerName[k].SID) {
                                        this.matchOddsData[i].runners[j].runner_name = this.matchOddsData[i].runnerName[k].RN
                                    }
                                }
                            }
                        }

                        this.fancyData?.ml?.sort(function (a, b) {
                            return a.mi - b.mi;
                        });

                        this.socketServiceCall()
                        // code commented because checking the open bets
                        if (this.favouriteGames?.length && this.favouriteGames.includes(parseInt(this.eventDetails.eventId))) {
                            this.eventDetails['favourite'] = true
                        } else {
                            this.eventDetails['favourite'] = false
                        }
                        if (this.$auth.status) {
                            this.getEventExposures();
                        }
                        if (!this.eventDetails.hasFancy && this.init) {
                            this.init = false;
                            this.selectedFancyTab = 'otherMarkets'
                        }
                    }
                }
            }).catch(error => {
                this.loading = false;
                this.$router.push({name: 'Home'});
                if (error) {
                    this.showErrorModalFunc(error?.data?.message);
                }
            });
        },
        getOpenBetsServiceCall() {
            if (!this.$auth.status) {
                return
            }
            this.loading = true;

            let data = {
                "type": 'sport',
                "sub_type": this.eventDetails.sportId,
                "status": 'open',
                "page_entries": this.pageEntries,
                "from": this.$dateTime.getDateSaperatedByDays(15),
                "to": this.$dateTime.getcurrentDate()
            }
            this.$apiCall('post', 'OPEN_BETS_EVENT_LISTING', data, 'user', { page: this.pageNo }).then(response => {
                this.loading = false;
                this.openBets = [];
                // this.totalPage = 0;
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0) {
                            this.showErrorModalFunc(response?.data?.debug[0]);
                        } else {
                            // this.serviceData = response?.data?.data;
                            // this.totalPage = this.serviceData?.last_page;
                            this.openBets = response?.data?.data?.data;
                        }
                    }
                }
            }).catch(error => {
                console.log("ERRRR", error)
                this.loading = false;
                if (error) {
                    this.showErrorModalFunc(error[0]);
                }
            });
        },
        getRunnerBookHtml(mid, sid, type) {
            if (this.betDetails && this.betDetails.market_id == mid && this.betDetails.runner_books) {
                if(!this.betDetails.stake) {
                    return ''
                }
                let runnerBook = this.betDetails.runner_books[sid];
                runnerBook = Math.floor(runnerBook).toFixed(2);
                if (runnerBook >= 0) {
                    return '<div class="positive profit-color">» ' + runnerBook + '</div>';
                } else {
                    return '<div class="negative loss-color">» ' + ((-1) * runnerBook) + '</div>';
                }
            } else {
                if (type == 'm' && this.marketBookAndExposure && this.marketBookAndExposure.marketsBook && this.marketBookAndExposure.marketsBook?.length) {
                    let marketRunners = this.marketBookAndExposure.marketsBook.find(mB => mB.id == mid);
                    if (marketRunners) {
                        let runnerBook = marketRunners.runner_book.find(mR => mR.selection_id == sid);
                        if (!runnerBook) return '';
                        if (parseFloat(runnerBook.pl) >= 0) {
                            return '<span class="back-win">' + parseFloat(runnerBook.pl).toFixed(2) + '</span>';
                        } else {
                            return '<span class="lay-loss">' + ((-1) * parseFloat(runnerBook.pl).toFixed(2)) + '</span>';
                        }
                    }
                } else if (type == 'b' && this.marketBookAndExposure && this.marketBookAndExposure.bookmakersBook && this.marketBookAndExposure.bookmakersBook?.length) {
                    let marketRunners = this.marketBookAndExposure.bookmakersBook.find(mB => mB.id == mid);
                    if (marketRunners) {
                        let runnerBook = marketRunners.runner_book.find(mR => mR.selection_id == sid);
                        if (!runnerBook) return '';
                        if (parseFloat(runnerBook.pl) >= 0) {
                            return '<span class="back-win">' + parseFloat(runnerBook.pl).toFixed(2) + '</span>';
                        } else {
                            return '<span class="lay-loss">' + ((-1) * parseFloat(runnerBook.pl).toFixed(2)) + '</span>';
                        }
                    }
                } else if (type == 'f' && this.marketBookAndExposure && this.marketBookAndExposure.fancyExposures && this.marketBookAndExposure.fancyExposures?.length) {
                    let marketRunner = this.marketBookAndExposure.fancyExposures.find(f => f.id == mid);
                    if (!marketRunner) return '';
                    return '<span class="lay-loss">' + ((-1) * parseFloat(marketRunner.exposures).toFixed(2)) + '</span>';
                } else {
                    return '';
                }
            }
        },
        getEventExposures() {
            this.loading = true;
            this.$apiCall('get', 'GET_EVENT_EXPOSURES', null, 'user', { matchId: this.eventDetails.matchId }).then(response => {
                this.loading = false;
                if (response) {
                    if (response.status == 200) {
                        this.marketBookAndExposure = response.data.data;
                        this.cashoutMarketData = {};
                        if(this.marketBookAndExposure) {
                            if(this.marketBookAndExposure.marketsBook) {
                                for(let i = 0; i < this.marketBookAndExposure.marketsBook.length; i++) {
                                    if(this.marketBookAndExposure.marketsBook[i].requiredCashout) {
                                        this.cashoutMarketData[this.marketBookAndExposure.marketsBook[i].id] = {type : 'market', value: null}
                                    }
                                }
                            }
                            if(this.marketBookAndExposure.bookmakersBook) {
                                for(let i = 0; i < this.marketBookAndExposure.bookmakersBook.length; i++) {
                                    if(this.marketBookAndExposure.bookmakersBook[i].requiredCashout) {
                                        this.cashoutMarketData[this.marketBookAndExposure.bookmakersBook[i].id] = {type: 'bookmaker', value: null}
                                    }
                                }
                            }
                        }
                        this.callCashout();
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    this.showErrorModalFunc(error?.data?.message);
                }
            });
        },
        selectScoreTab(current_tab) {
            this.current_score_tab = current_tab
        },
        changeFancyCategory(data) {
            if(data.value == 'premium_fancy'){
                 this.isPremium = true;
                 this.selectFancyTab('premiumFancy');
            }else{
                this.isPremium = false;
                this.selectedFancyCategory = data; 
            }
        },
        changeAcceptOdds() {
            // this.current_bet.accept_any_odds = !this.current_bet.accept_any_odds
            let user = this.$store.getters.stateUser;
            if (user.accept_any_odds === undefined) {
                user.accept_any_odds = true;
            } else if (user.accept_any_odds) {
                user.accept_any_odds = false;
            } else {
                user.accept_any_odds = true;
            }
            this.$store.dispatch('setUser', user);
        },
        setStakeValue(stake) {
            this.betDetails['stake'] = (this.betDetails['stake'] ? this.betDetails['stake'] : 0) + parseFloat(stake);
            this.maxStakes()
            this.calculationOfProfitLoss();
        },
        oddsMinus() {
            var changeOddsVia = 0;
            if (parseFloat(this.betDetails.odds).toFixed(2) > 1.00 && parseFloat(this.betDetails.odds).toFixed(2) < 2.00) {
                changeOddsVia = 0.01;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 2.00 && parseFloat(this.betDetails.odds).toFixed(2) < 3.00) {
                changeOddsVia = 0.02;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 3.00 && parseFloat(this.betDetails.odds).toFixed(2) < 4.00) {
                changeOddsVia = 0.05;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 4.00 && parseFloat(this.betDetails.odds).toFixed(2) < 6.00) {
                changeOddsVia = 0.10;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 6.00 && parseFloat(this.betDetails.odds).toFixed(2) < 10.00) {
                changeOddsVia = 0.20;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 10.00 && parseFloat(this.betDetails.odds).toFixed(2) < 20.00) {
                changeOddsVia = 0.50;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 20.00 && parseFloat(this.betDetails.odds).toFixed(2) < 30.00) {
                changeOddsVia = 1.00;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 30.00 && parseFloat(this.betDetails.odds).toFixed(2) < 50.00) {
                changeOddsVia = 2.00;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 50.00 && parseFloat(this.betDetails.odds).toFixed(2) < 100.00) {
                changeOddsVia = 5.00;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 100.00) {
                changeOddsVia = 10.00;
            }
            if (this.betDetails.odds > 0) {
                this.betDetails.odds = (parseFloat(this.betDetails.odds) - changeOddsVia).toFixed(2);
                this.calculationOfProfitLoss();
            }
        },
        oddsPlus() {
            var changeOddsVia = 0;
            if (parseFloat(this.betDetails.odds).toFixed(2) > 1.00 && parseFloat(this.betDetails.odds).toFixed(2) < 2.00) {
                changeOddsVia = 0.01;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 2.00 && parseFloat(this.betDetails.odds).toFixed(2) < 3.00) {
                changeOddsVia = 0.02;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 3.00 && parseFloat(this.betDetails.odds).toFixed(2) < 4.00) {
                changeOddsVia = 0.05;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 4.00 && parseFloat(this.betDetails.odds).toFixed(2) < 6.00) {
                changeOddsVia = 0.10;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 6.00 && parseFloat(this.betDetails.odds).toFixed(2) < 10.00) {
                changeOddsVia = 0.20;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 10.00 && parseFloat(this.betDetails.odds).toFixed(2) < 20.00) {
                changeOddsVia = 0.50;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 20.00 && parseFloat(this.betDetails.odds).toFixed(2) < 30.00) {
                changeOddsVia = 1.00;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 30.00 && parseFloat(this.betDetails.odds).toFixed(2) < 50.00) {
                changeOddsVia = 2.00;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 50.00 && parseFloat(this.betDetails.odds).toFixed(2) < 100.00) {
                changeOddsVia = 5.00;
            } else if (parseFloat(this.betDetails.odds).toFixed(2) >= 100.00) {
                changeOddsVia = 10.00;
            }
            if (this.betDetails.odds > 0) {
                this.betDetails.odds = (parseFloat(this.betDetails.odds) + changeOddsVia).toFixed(2);
                this.calculationOfProfitLoss();
            }
        },
        calculationOfProfitLoss() {
            this.betDetails.pl = 0;
            if (this.betDetails.bet_type == 'bookmaker') {
                this.betDetails.pl = ((this.betDetails.odds / 100) * this.betDetails.stake);
            } else if (this.betDetails.bet_type == 'market') {
                this.betDetails.pl = (this.betDetails.odds * this.betDetails.stake) - this.betDetails.stake;
            } else {
                this.betDetails.pl = Math.floor(this.betDetails.selection_type == 'back' ? (this.betDetails.stake * this.betDetails.oy) / 100 : (this.betDetails.stake * this.betDetails.on) / 100);
            }
            if (this.betDetails.bet_type == 'fancy') return;
            this.calBookForRunners();
        },
        calBookForRunners() {
            this.betDetails.runner_books = {};
            let marketRunners = [];
            if (this.betDetails.bet_type == 'market') {
                if (this.marketBookAndExposure && this.marketBookAndExposure.marketsBook && this.marketBookAndExposure.marketsBook?.length) {
                    marketRunners = this.marketBookAndExposure.marketsBook.find(mB => mB.id == this.betDetails.market_id);
                    if (!marketRunners) {
                        marketRunners = this.betDetails.market.runners;
                    } else {
                        marketRunners = marketRunners.runner_book;
                    }
                } else {
                    marketRunners = this.betDetails.market.runners;
                }
                for (let mRunner of marketRunners) {
                    this.betDetails.runner_books[mRunner.sid ? mRunner.sid : mRunner.selection_id] = mRunner.pl ? mRunner.pl : 0;
                }
            } else if (this.betDetails.bet_type == 'bookmaker') {
                if (this.marketBookAndExposure && this.marketBookAndExposure.bookmakersBook && this.marketBookAndExposure.bookmakersBook?.length) {
                    marketRunners = this.marketBookAndExposure.bookmakersBook.find(mB => mB.id == this.betDetails.market_id);
                    if (!marketRunners) {
                        marketRunners = this.betDetails.market.sl;
                    } else {
                        marketRunners = marketRunners.runner_book;
                    }
                } else {
                    marketRunners = this.betDetails.market.sl;
                }
                for (let mRunner of marketRunners) {
                    this.betDetails.runner_books[mRunner.si ? mRunner.si : mRunner.selection_id] = mRunner.pl ? mRunner.pl : 0;
                }
            }
            // runner book is not exist
            for (var selection_id of Object.keys(this.betDetails.runner_books)) {
                if (this.betDetails.runner_selection_id == selection_id) {
                    if (this.betDetails.selection_type == 'back') {
                        this.betDetails.runner_books[selection_id] += parseFloat(this.betDetails.pl);
                    } else {
                        this.betDetails.runner_books[selection_id] -= parseFloat(this.betDetails.pl);
                    }
                } else {
                    if (this.betDetails.selection_type == 'back') {
                        this.betDetails.runner_books[selection_id] -= parseFloat(this.betDetails.stake);
                    } else {
                        this.betDetails.runner_books[selection_id] += parseFloat(this.betDetails.stake);
                    }
                }
            }
        },
        addBet(market, runner, selection_type, bet_type, r_index, event) {
            if (!this.$auth.status) {
                this.showErrorModalFunc(this.$t('login-to-place-bets','Please login to place the bets'));
                return
            } else {
                let user = this.$store.getters.stateUser;
                if (!market || ((bet_type == 'market' || bet_type == 'bookmaker') && !runner) ||
                    (bet_type == 'market' && ((market && market.st != 'OPEN') || (runner && runner.s != 'ACTIVE'))) ||
                    (bet_type == 'bookmaker' && ((market && market.sn != 'ONLINE') || (runner && runner.ss != 'ACTIVE')))
                    || (bet_type == 'fancy' && market.sn != 'ONLINE')) {
                    this.showErrorModalFunc(this.$t('market-not-active','Market is not active!'));
                    return
                }
                this.setBetslipCount(market, bet_type);
                this.betDetails = {};
                this.betDetails['match_id'] = this.eventDetails.matchId;
                // this.betDetails['min_stake'] = bet_type == 'fancy' ? market.mins : (market.min_stake_limit ? market.min_stake_limit : 100);
                // this.betDetails['max_stake'] = bet_type == 'fancy' ? market.ms : (market.stake_limit ? market.stake_limit : 2000);
                this.betDetails['min_stake'] = (bet_type == 'fancy' || bet_type == 'bookmaker') ? market.mins : (market.min_stake_limit ? market.min_stake_limit : 100);
                this.betDetails['max_stake'] = (bet_type == 'fancy' || bet_type == 'bookmaker') ? market.ms : (market.stake_limit ? market.stake_limit : 2000);
                this.betDetails['sport_id'] = this.eventDetails.sportId;
                this.betDetails['eventId'] = this.eventDetails.eventId;
                this.betDetails['selection_type'] = selection_type;
                this.betDetails['bet_type'] = bet_type;
                this.betDetails['accept_any_odds'] = user.accept_any_odds === undefined ? false : user.accept_any_odds;
                this.betDetails['market'] = market;
                this.betDetails['bet_delay'] = (bet_type == 'fancy' || bet_type == 'bookmaker') ? (market.bd || 0) : (market.bet_delay || 0);
                this.betDetails['runner'] = runner;
                this.betDetails['rIndex'] = r_index;
                this.betDetails['bet_time'] = Math.round(Date.now() / 1000);
                if (this.betDetails.bet_type == 'market') {
                    this.betDetails['market_id'] = market.mid;
                    this.betDetails['runner_name'] = runner.runner_name;
                    this.betDetails['runner_selection_id'] = runner.sid;
                    this.betDetails['odds'] = (runner.ex && runner.ex[selection_type == 'back' ? 'b' : 'l'] && runner.ex[selection_type == 'back' ? 'b' : 'l'][0]) ? runner.ex[selection_type == 'back' ? 'b' : 'l'][0].p : '';
                    this.betDetails['screen_odds'] = (runner.ex && runner.ex[selection_type == 'back' ? 'b' : 'l'] && runner.ex[selection_type == 'back' ? 'b' : 'l'][0]) ? runner.ex[selection_type == 'back' ? 'b' : 'l'][0].p : '';
                } else if (this.betDetails.bet_type == 'bookmaker') {
                    this.betDetails['market_id'] = market.mi;
                    this.betDetails['runner_name'] = runner.sln;
                    this.betDetails['runner_selection_id'] = runner.si;
                    this.betDetails['odds'] = runner[selection_type == 'back' ? 'b' : 'l'];
                    this.betDetails['screen_odds'] = runner[selection_type == 'back' ? 'b' : 'l'];
                } else {
                    this.betDetails['runner_name'] = market.mn;
                    this.betDetails['market_id'] = market.mi;
                    this.betDetails['runner_selection_id'] = market.mi;
                    this.betDetails['fancy_data'] = 1;
                    this.betDetails['odds'] = market[selection_type == 'back' ? 'ry' : 'rn'];
                    this.betDetails['bhav'] = market.cat == 'line_markets' ? 100 : market[selection_type == 'back' ? 'oy' : 'on'];
                    this.betDetails['screen_odds'] = market[selection_type == 'back' ? 'ry' : 'rn'];
                }
                this.showBetSlip(market, runner, bet_type, event);
                if (this.getClickBetValue) {
                    for (var i = 0; i < this.getClickBetValue?.length; i++) {
                        if (this.getClickBetValue[i].isSelected) {
                            this.betDetails.stake = this.getClickBetValue[i].value
                            setTimeout(() => {
                                this.saveBets();
                            }, 1000)
                        }
                    }
                }
                //  else {
                //     this.showBetSlip(market, runner, bet_type, event);
                //     // this.showBetSlip(divId);
                // }
            }
        },
        setBetslipCount(market, bet_type) {
            let user = { ...this.$store.getters.stateUser };
            let betslipCount = { ...(user.betslipCount && user.betslipCount.eventId == this.event_id ? user.betslipCount : { eventId: this.event_id }) };

            let betSlipObject = {
                exp: Math.round(Date.now() / 1000) + 180 // 180 seconds for 3 minutes
            };

            if (bet_type === 'market') {
                betslipCount[market.mid] = betslipCount[market.mid] || [];
                betslipCount[market.mid].push(betSlipObject);
            } else if (bet_type === 'bookmaker' || bet_type === 'fancy') {
                betslipCount[market.mi] = betslipCount[market.mi] || [];
                betslipCount[market.mi].push(betSlipObject);
            }
            this.$store.dispatch('setUser', { ...user, betslipCount });
        },
        counterStartForCloseBet() {
            clearInterval(this.betCloseSetTimeOut);
            this.betCloseSetTimeOut = setInterval(() => {
                var current_time = Math.round(Date.now() / 1000);
                if (current_time - this.betDetails.bet_time > 9) {
                    this.cancleBetSlip();
                }
            }, 1000);
        },
        clearStake() {
            if (this.betDetails && this.betDetails.betLoader) return;
            this.betDetails.stake = 0;
            let runner = this.betDetails.runner;
            let selection_type = this.betDetails.selection_type;
            if (this.betDetails.bet_type == 'market') {
                this.betDetails['odds'] = (runner.ex && runner.ex[selection_type == 'back' ? 'b' : 'l'] && runner.ex[selection_type == 'back' ? 'b' : 'l'][0]) ? runner.ex[selection_type == 'back' ? 'b' : 'l'][0].p : '';
            }
            this.calculationOfProfitLoss();
        },
        cancleBetSlip() {
            this.betDetails = {};
            clearInterval(this.betCloseSetTimeOut);
            this.renderBetSlip = false
            // this.betSlipModal.hide();
            this.$helper.closeModal('bet-slip-modal')
        },
        showBetSlip(market, runner, bet_type, event) {
            let mid = '';
            let rsid = '';
            if (bet_type == 'fancy') {
                mid = rsid = market.mi;
                rsid = market.mi;
            } else {
                mid = market.mid ? market.mid : (market.mi ? market.mi : 0);
                rsid = runner ? (runner.sid ? runner.sid : (runner.si ? runner.si : 0)) : 0
            }
            this.renderBetSlip = true
            // this.betSlipModal.show();
            this.$helper.openModal('#bet-slip-modal')

            // this.$nextTick().then(() => {
            //     const betSlipElement = this.$refs.BetSlip
            //     if (betSlipElement) {
            //         event.target.closest('.bet-slip-area').appendChild(betSlipElement);
            //     }
            // });
            this.counterStartForCloseBet();
        },
        gotoEvent(event_id) {
            this.event_id = event_id
            this.getEventDetails()
        },
        makeFavourite(match) {
            if (!this.$auth.status) {
                this.showErrorModalFunc(this.$t('please-login-first','Please login first!'));
                return
            }
            this.fav = true
            this.loading = true;
            let data = {
                "match_id": match.eventID,
                "game_type": 0,
            };
            this.$apiCall('post','MAKE_FAVOURITE',data).then(response => {
                this.loading = false;
                if (response) {
                    if (response.status == 200) {
                        let currFav = this.$store.getters.favouriteGames;
                        if (currFav.includes(Number(match.eventID))) {
                            currFav = currFav.filter(cf => cf !== Number(match.eventID));
                        } else {
                            currFav.push(Number(match.eventID));
                        }
                        this.$store.dispatch('setFavouriteGames', currFav);
                        this.eventDetails.favourite = !this.eventDetails.favourite
                        this.showSuccessModalFunc(response.data.message)

                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    this.showErrorModalFunc(error?.data?.message);
                }
            });
        },
        async saveBets() {
            this.loader = true;
            this.displayLoader = true;
            if (!this.betDetails.stake || !this.betDetails.odds) {
                this.showErrorModalFunc(this.$t('stake-field-is-req','Stake field is required!'));
                this.displayLoader = false

                this.loader = false;
                return;
            }
            if (this.betDetails.stake < this.betDetails.min_stake) {
                this.$errorToast('Stake is too Low!');
                this.displayLoader = false
                this.loader = false;
                return;
            }
            if (this.betDetails.stake > this.betDetails.max_stake) {
                this.$errorToast('Stake is too HIGH!');
                this.displayLoader = false
                this.loader = false;
                return;
            }
            if (!this.betDetails.accept_any_odds) {
                this.betDetails.accept_any_odds = 0;
            }
            if (this.betDetails.betLoader) {
                this.displayLoader = false
                this.loader = false;
                return;
            }
            let user = this.$store.getters.stateUser;
            
            let slipCount = user.betslipCount[this.betDetails.market_id];
            let currTime =  Math.round(Date.now() / 1000);
            for(let i = 0; i<slipCount.length; i++) {
                if(slipCount[i].exp < currTime) {
                    slipCount.splice(i, 1)
                }
            }
            if(slipCount.length > 2) {
                this.betDetails.slip_count = slipCount.length;
            }
            this.betDetails.bet_user_guid = Math.random().toString(36);
            this.betDetails.betLoader = true;
            clearInterval(this.betCloseSetTimeOut);
            let data = this.getBetDetails();
            this.$apiCall('post', 'PLACE_ORDER', data).then(response => {
                    if (response && response.status == 200) {
                        this.displayLoader = false
                        this.loader = false;
                        if (this.betDetails.bet_type == 'market') {
                            if (this.marketBookAndExposure && this.marketBookAndExposure.marketsBook && this.marketBookAndExposure.marketsBook?.length) {
                                let marketBook = this.marketBookAndExposure.marketsBook.find(m => m.id == this.betDetails.market_id);
                                if (!marketBook) {
                                    this.marketBookAndExposure.marketsBook.push({ id: this.betDetails.market_id, runner_book: response.data.data.runner_book })
                                } else {
                                    marketBook.runner_book = response.data.data.runner_book;
                                }
                            } else {
                                this.marketBookAndExposure = {
                                    marketsBook: [{ id: this.betDetails.market_id, runner_book: response.data.data.runner_book }]
                                };
                            }
                        } else if (this.betDetails.bet_type == 'bookmaker') {
                            if (this.marketBookAndExposure && this.marketBookAndExposure.bookmakersBook && this.marketBookAndExposure.bookmakersBook?.length) {
                                let marketBook = this.marketBookAndExposure.bookmakersBook.find(m => m.id == this.betDetails.market_id);
                                if (!marketBook) {
                                    this.marketBookAndExposure.bookmakersBook.push({ id: this.betDetails.market_id, runner_book: response.data.data.runner_book })
                                } else {
                                    marketBook.runner_book = response.data.data.runner_book;
                                }
                            } else {
                                this.marketBookAndExposure = {
                                    bookmakersBook: [{ id: this.betDetails.market_id, runner_book: response.data.data.runner_book }]
                                };
                            }
                        } else {
                            if (!(this.marketBookAndExposure && this.marketBookAndExposure.fancyExposures && this.marketBookAndExposure.fancyExposures?.length)) {
                                this.marketBookAndExposure.fancyExposures = [];
                            }
                            if (this.marketBookAndExposure && this.marketBookAndExposure.fancyExposures && this.marketBookAndExposure.fancyExposures?.length) {
                                let fancyExpoIndex = this.marketBookAndExposure.fancyExposures.findIndex(f => f.id == this.betDetails.market_id);
                                if (fancyExpoIndex >= 0) {
                                    this.marketBookAndExposure.fancyExposures[fancyExpoIndex].exposures = response.data.data.exposure;
                                } else {
                                    this.marketBookAndExposure.fancyExposures.push({ id: this.betDetails.market_id, exposures: response.data.data.exposure });
                                }
                            }
                        }
                        user.exposure = response.data.data.total_exposure;
                        user.betslipCount[this.betDetails.market_id] = [];
                        this.$store.dispatch('setUser', user);
                        this.getEventExposures();
                        this.cancleBetSlip()
                        this.showSuccessModalFunc(response.data.message);
                    } else {
                        this.betDetails.bet_time = Math.round(Date.now() / 1000);
                        this.counterStartForCloseBet();
                        this.betDetails.betLoader = false;
                        this.showErrorModalFunc(response.data.message);
                    }
                
            }).catch(error => {
                this.loader = false;
                this.displayLoader = false
                this.betDetails.betLoader = false;
                if (error) {
                    this.betDetails.bet_time = Math.round(Date.now() / 1000);
                    this.counterStartForCloseBet();
                    this.showErrorModalFunc(error[0]);
                }
            });
        },
        getBetDetails() {
            return {
                "runner_name": this.betDetails['runner_name'],
                "odds": this.betDetails['odds'],
                "market_id": this.betDetails['market_id'].toString(),
                "runner_selection_id": this.betDetails['runner_selection_id'],
                "match_id": this.betDetails['match_id'],
                "selection_type": this.betDetails['selection_type'],
                "bet_type": this.betDetails['bet_type'],
                "eventId": this.betDetails['eventId'],
                "rIndex": this.betDetails['rIndex'],
                "bet_user_guid": this.betDetails.bet_user_guid,
                "sport_id": this.betDetails['sport_id'],
                "min_stake": this.betDetails['min_stake'],  
                "max_stake": this.betDetails['max_stake'],
                "accept_any_odds": this.betDetails['accept_any_odds'],
                "stake": this.betDetails['stake'],
                "validate": 0,
                "bhav": this.betDetails['bhav'],
                "slip_count": this.betDetails['slip_count'],
                "betId": this.$dateTime.currentTimestamp(),
                "userid": this.$auth.user.userid,
                "bet_delay": this.betDetails['bet_delay'],
                "screen_odds": this.betDetails['screen_odds'] 
            }
        },
        socketServiceCall() {
            socketService.on("App\\\\Events\\\\SportsBroadcastData", (mainMarketOdds) => {
                if (mainMarketOdds && mainMarketOdds?.length) {
                    for (let mRunner of mainMarketOdds) {
                        let mOddsData = this.matchOddsData.find(m => m.mid == mRunner.mid);
                        if (!mOddsData || (mRunner && !mRunner.runners?.length)) continue;
                        for (let runner of mRunner.runners) {
                            let mOddsDataRuuner = mOddsData.runners.find(r => r.sid == runner.sid);
                            if (!mOddsDataRuuner || (runner && !runner.ex)) continue;
                            // back available 
                            if (runner.ex.b) {
                                mOddsDataRuuner.ex.b = runner.ex.b;
                            }
                            // lay available
                            if (runner.ex.l) {
                                mOddsDataRuuner.ex.l = runner.ex.l;
                            }
                        }
                    }
                }
            });
            socketService.on("App\\\\Events\\\\BroadcastBookmaker", (bookmakerOdds) => {
                if (bookmakerOdds && bookmakerOdds?.length) {
                    let ml = bookmakerOdds[0].ml
                    if (!ml || (ml && !ml.updated)) return;
                    // process updated data
                    let updatedList = ml.updated;
                    if (updatedList && updatedList?.length) {
                        for (let market of updatedList) {
                            let bData = this.bookmakerData.ml.find(b => b.mi == market.mi);
                            if (!bData) continue;
                            let marketKeys = Object.keys(market);
                            for (let mKey of marketKeys) {
                                if (mKey == 'mi') {
                                    continue;
                                } else if (mKey == 'sl') {
                                    for (let selection of market.sl) {
                                        let bDataSelection = bData.sl.find(s => s.si == selection.si);
                                        if (!bDataSelection) continue;
                                        let selectionKeys = Object.keys(selection);
                                        for (let sKey of selectionKeys) {
                                            bDataSelection[sKey] = selection[sKey];
                                        }
                                    }
                                } else {
                                    bData[mKey] = market[mKey];
                                }
                            }
                        }
                    }
                }
            });
            socketService.on("App\\\\Events\\\\BroadcastFancy", (fancyOdds) => {
                if (fancyOdds && fancyOdds?.length) {
                    let ml = fancyOdds[0].ml
                    if (!ml || ((ml && !ml.updated) && (ml && !ml.added) && (ml && !ml.deleted))) return;
                    // process updated data
                    let updatedList = ml.updated;
                    let addedList = ml.added;
                    let deletedList = ml.deleted;
                    // remove deleted fancies
                    if (deletedList && deletedList?.length) {
                        this.fancyData.ml = this.fancyData.ml.filter(function (m) {
                            return !deletedList.includes(m.mi)
                        });
                    }
                    // update updated fancies
                    if (updatedList && updatedList?.length) {
                        for (let market of updatedList) {
                            let fData = this.fancyData.ml.find(f => f.mi == market.mi);
                            if (!fData) continue;
                            let marketKeys = Object.keys(market);
                            for (let mKey of marketKeys) {
                                if (mKey == 'mi') {
                                    continue;
                                } else {
                                    fData[mKey] = market[mKey];
                                }
                            }
                        }
                    }
                    // merged with old fancies array
                    if (addedList && addedList.length) {
                        for(let i = 0; i< addedList.length; i++) {
                            let checkExistingFancy = this.fancyData.ml.find(fD => fD.mi == addedList[i].mi)
                            if(!checkExistingFancy) {
                                this.fancyData.ml = [...this.fancyData.ml, addedList[i]]
                            }
                        }
                    }
                }
            });
        },
        showErrorModalFunc(message) {
            this.$errorToast( message);
        },
        showSuccessModalFunc(message) {
            this.$successToast(message);
        },
        getfancyBook(fancy_id) {
            if (!this.$auth.status) {
                return;
            }
            if (!(this.marketBookAndExposure && this.marketBookAndExposure.fancyExposures && this.marketBookAndExposure.fancyExposures?.length)) {
                return;
            }
            this.fancyBookPositions = []
            let fancyExpoIndex = this.marketBookAndExposure.fancyExposures.findIndex(f => f.id == fancy_id);
            if (fancyExpoIndex < 0) {
                // let fancyBookModal = new Modal('#run-position-modal');
                // fancyBookModal.show()
                this.showErrorModalFunc(this.$t('no-run-position-available',"No Run Position Available!"));
                return
            };
            this.$apiCall('post', 'GET_FANCY_BOOK', { id: fancy_id, match_id: this.eventDetails.matchId, fancy_market_id: 1 }).then(response => {
                if (response.status == 200 && response.data && response.data.data.book) {
                    this.fancyBookPositions = response.data.data.book;
                    this.$helper.openModal('#run-position-modal')
                } else {
                    this.showErrorModalFunc(response?.data?.message);
                }
            }).catch(error => {
                if (error) {
                    this.showErrorModalFunc(error?.data?.message);
                }
            });
        },
        updateEventDetails(value) {
            this.event_id = value.event_id
            this.getEventDetails()

        },
        isNegative(num) {
            if (Math.sign(num) === -1) {
                return true;
            }
            return false;
        },
        // Low Balance
        toggleLowBalanceModal(){
            const modal = document.getElementById('LowBalanceModal');
            if(!modal.classList.contains('show')){
                this.$helper.openModal('#LowBalanceModal');
            }
        },
        getMarketDataByName(marketName = 'main_market') {
			const marketData = this.getBetandAvgOdds.find(item => item.market === marketName);
			return marketData || {
				market: marketName,
				lay: { odds: 0, stake: 0, pl: 0, betCount: 0 },
				back: { odds: 0, stake: 0, pl: 0, betCount: 0 }
			};
		}
    },
    beforeUnmount() {
        socketService.off('App\\\\Events\\\\SportsBroadcastData');
        socketService.off('App\\\\Events\\\\BroadcastBookmaker');
        socketService.off('App\\\\Events\\\\BroadcastFancy');
        socketService.emit("leave", [this.event_id]);
        if (this.intervalTimer) {
            clearInterval(this.intervalTimer);
        }
    },

}
</script>

<style scoped>
.back-background {
    background: #72bbef;
}

.lay-background {
    background: #faa9ba;
}

.btn.cashout-btn {
    background-color: #ffeb3b;
    color: #000;
    border: 1px solid #000000;
    padding: 2px 5px;
    margin-left: 10px;
}

.cashout-modal .modal-banner-sec {
    text-align: center;
    padding-bottom: 15px;
}

.cashout-modal .cancle-but,
.cashout-modal .place-but {
    width: 100%
}

.cashout-modal .back-thm-modal {
    padding: 15px 0 30px 0;
}

.open-bets-details-model .modal {
    z-index: 999999;
}

@keyframes stretch {
    0% {
        transform: scale(0.5);
        background-color: #B5DDF0;
    }

    50% {
        background-color: #CFE9F6;
    }

    100% {
        transform: scale(1);
        background-color: #FFFFFF;
    }
}

.btn.btn-loading {
    font-size: 0;
}

.btn.btn-loading span {
    display: flex;
    justify-content: center;
}

.btn.btn-loading span b {
    animation-direction: alternate;
    animation-duration: 0.5s;
    animation-fill-mode: none;
    animation-iteration-count: infinite;
    animation-name: stretch;
    animation-play-state: running;
    animation-timing-function: ease-out;
    border-radius: 100%;
    display: block;
    height: 10px;
    margin: 0 1px;
    width: 10px;
    animation-delay: 0.1s;
    margin: 0 5px;
}

.btn.btn-loading span b:first-child {
    animation-delay: 0s;
    margin: 0;
}

.btn.btn-loading span b:last-child {
    animation-delay: 0.2s;
    margin: 0;
}

.btn span {
    display: none;
}

.placed-bet-btn.btn-loading {
    padding: 10px;
}




</style>